import React,{useContext, useState,useEffect,useLayoutEffect,useRef, useCallback} from 'react'
import {Form, Row, Col } from 'react-bootstrap'
import ElemDeleteControl from "./ElemDeleteControlWrapper"
import styles2 from '../css/COLUMN.module.css'
import {AppContext} from '../../Resources/CanvasContextFile'
import { StyleSheet, css } from 'aphrodite';
import {CSSPreparation1} from '../../components/Properties/CSSPreparation1.jsx';
import CSSKeys from '../../components/Properties/CSSPropertiesKeys';
import {ThemeJSON} from '../../components/IFormDesignerLayout/Theme/ThemeJSON';
import {TextField, FormControl,IconButton} from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from "../../ReusableComponents/Tooltip/Tooltip";
import Typography from '@material-ui/core/Typography';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import PrepareCSSClass from '../../components/IFormDesignerLayout/PrepareCSSClass'
import { sendRequestToUpdateValue } from '../../components/IFormDesignerLayout/RequestLogic'
import EditableLabel from '../../ReusableComponents/EditableLabel/EditableLabel'
import QuickTools from '../../ReusableComponents/QuickTools/QuickTools';
import {triggerEventCalls} from '../../ReusableComponents/Events/EventExecutionLogic';
import { getSuggestedId } from "../../components/IFormDesignerLayout/Logic/UserIdLogic";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import "../../ReusableComponents/Tooltip/tooltip.css";
import MandatoryMsg from '../../ReusableComponents/ErrorMessageComponent/MandatoryMsg'
import ErrorMessageComponent from '../../ReusableComponents/ErrorMessageComponent/ErrorMessageComponent';
import { handleDisplayProperty,encrypt,decryptMessage, updateValue, setMandatoryControls, updatePartialJSON, loadArabicImage, getTabIndex } from '../../components/IFormDesignerLayout/IFormDesignerLogic'
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { GetState, GetStateFromData, useElementWidth } from '../../components/CustomHooks/CustomHooks'
import { useTranslation } from 'react-i18next'
import { functions, renderExecuteServerEventAPIData } from '../../components/IFormDesignerLayout/ApplicationAPI/applicationApi.js'
import useRender from '../../components/CustomHooks/useRender.js'

const TEXTBOX = (props) => {
    const useStyles = makeStyles(({
        textfieldRoot: {
            // '&:hover': {
            //         '& .MuiOutlinedInput-root': {
            //          // '& fieldset': {
            //             boxShadow: "0px 3px 4px rgba(0, 114, 198, 0.10)",
            //             borderRadius: styles => styles?.BorderRadius ? styles.BorderRadius : '2px',
            //             //borderWidth:  styles => styles?.BorderWidth ? styles.BorderWidth : '1px',
            //             border: "1px #99C7E8 solid",
            //             borderColor: '#99C7E8'
            //         //  },
            //         },
            //       },
            '& label.Mui-focused': {
                backgroundColor: styles => styles.ControlStyle === "Style3" ? styles.secBackColor : "initial"
            }, 
        "& .MuiInputAdornment-positionEnd": {
          marginLeft: (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") ? "8px" : "none",
      },
            '& .MuiOutlinedInput-input' : {
                zIndex: styles=>styles.ControlStyle==="Style3" ? 1 : 'unset',
                color: styles=> styles.FontColor + " !important",
                textTransform:(styles) => styles.CharacterSet,
            },
            '& .MuiInputLabel-outlined':{
                transform : "translate(14px, 10px) scale(1) !important",
                right:styles=>styles.ControlStyle==="Style3" && (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") ?"20px":null,
                left:styles=>styles.ControlStyle==="Style3" && (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") ?"unset":null
            },
            "& .MuiIconButton-root" : {
        margin: (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ) && isEnable === "false" ? "0px !important" :"",
        marginRight : "4px !important",

    },
    '& .MuiInputAdornment-positionStart':{
        marginRight:'0px !important'
    },
            '& .MuiOutlinedInput-adornedEnd': {
                paddingRight: "0px !important"
            },
            '& .MuiOutlinedInput-root input:not([type="button"]):not([type="submit"]):not([readonly="readonly"]):not([type="checkbox"]):focus':{
                border:"none !important",
                boxShadow: styles => (styles.ControlStyle==="Style3" || styles?.ControlStyle === "Style2" || styles?.ControlStyle === "Style1") && "none !important"
              },
              
            '& input:not([type="button"]):not([type="submit"]):not([readonly="readonly"]):not([type="checkbox"]).MuiInputBase-input' : {
                // '&:hover': {
                //     '& .MuiOutlinedInput-root': {
                //      // '& fieldset': {
                //         boxShadow: "0px 3px 4px rgba(0, 114, 198, 0.10)",
                //         borderRadius: styles => styles?.BorderRadius ? styles.BorderRadius : '2px',
                //         //borderWidth:  styles => styles?.BorderWidth ? styles.BorderWidth : '1px',
                //         border: "1px #99C7E8 solid",
                //         borderColor: '#99C7E8'
                //     //  },
                //     },
                //   },
                height: styles=> styles.height1 + ' !important' ,
                color: styles=> (styles.FontColor1 || styles.themeFontColor1 || styles?.basicThemeFontColor1) + ' !important' ,
                fontWeight: styles => styles.FontWeight + ' !important',
                fontSize: styles => styles.FontSize + " !important",
                fontStyle: styles => styles.FontStyle + ' !important',
                fontFamily: styles => styles.FontFamily + ' !important',
                borderColor: styles=>styles.BorderColor,
                outlineColor: styles=>styles.BorderColor + ' !important',
                paddingLeft: "8px !important"
            },
            "& .MuiInputBase-input::placeholder" : {
                background: "none !important",
                opacity: "1 !important",
                color: "#606060 !important",
                fontSize: styles=> styles.FontSize + " !important",
                fontFamily: styles => styles.FontFamily + ' !important',
            },
            '& .MuiInputBase-input:focus' : {
                height: styles=> styles.height1 + ' !important' ,
                color: styles=> (styles.FontColor1 || styles.themeFontColor1 || styles?.basicThemeFontColor1) + ' !important' ,
                fontSize: styles => styles.FontSize + " !important",
                borderColor: styles=>styles.BorderColor + ' !important',
                outlineColor: styles=>styles.BorderColor + ' !important',
                fontWeight: styles => styles.FontWeight + ' !important',
                fontStyle: styles => styles.FontStyle + ' !important',
                fontFamily: styles => styles.FontFamily + ' !important',
                borderRadius: styles => styles?.BorderRadius + ' !important',
                boxShadow: styles=> styles.ControlStyle === "Style2" && " none !important" ,
                // paddingLeft: "0px !important"
            },
           '& .MuiInput-underline':{
              borderBottomColor: styles=> styles?.showMandatoryMsg ?  "#c32525" : styles.BorderColor,
              borderBottomWidth: styles=>styles.BorderWidth,
              borderBottomLeftRadius: (styles) => 
          styles?.ControlStyle === "Style2" ? "none !important" : styles.BorderRadius,
        borderBottomRightRadius: (styles) => 
          styles?.ControlStyle === "Style2" ? "none !important" : styles.BorderRadius,
              borderStyle: 'solid',
              borderTop : 'none !important',
              borderLeft : 'none !important',
              borderRight : 'none !important'
            },
            '& .MuiInput-underline input:not([type="button"]):not([type="submit"]):not([readonly="readonly"]):not([type="checkbox"]):focus':{
                border: styles=> styles.ControlStyle === "Style2" && " none !important" 
              },
            '& .MuiInput-underline:before':{
                border:"none",
              },
            //   '& .MuiInput-underline:hover':{
            //     borderBottom: "1px solid #99C7E8 !important",
            //     borderBottomStyle: "none",
            //     boxShadow: "0px 3px 4px rgba(0, 114, 198, 0.10) !important",
            //     },
                '& .MuiInput-underline:hover':{
                // borderBottom: "1px solid #99C7E8 !important",
                borderBottomColor: "#99C7E8 !important",
                borderBottomWidth: styles => styles?.BorderWidth ? styles?.BorderWidth + " ! important" : "1px !important",
                borderBottomRadius: styles => styles?.BorderRadius ? styles?.BorderRadius : "none",
                borderBottomStyle: "solid",
                boxShadow: "0px 3px 4px rgba(0, 114, 198, 0.10) !important",
             },
             '& .MuiInput-underline.Mui-focused':{
                // borderBottom: "1px solid #99C7E8 !important",
                borderBottomColor: "#0072c6 !important",
                borderBottomWidth: styles => styles?.BorderWidth ? styles?.BorderWidth + " ! important" : "1px !important",
                borderBottomRadius: styles => styles?.BorderRadius ? styles?.BorderRadius : "none",
                borderBottomStyle: "solid",
                // boxShadow: "0px 3px 4px rgba(0, 114, 198, 0.10) !important",
             },
              '& .MuiInput-underline:after':{
                // borderBottom: "1px solid #99C7E8 !important",
                borderBottom: "none"
             },
                '& .MuiInput-underline:hover:not(.Mui-disabled):before':{
                    border: "none",
                },
            "& .MuiInputBase-inputAdornedStart":{
                textAlign:(styles) => styles.TextAlignment,
                textTransform:(styles) => styles.CharacterSet,
            },
    
            '& .MuiInputLabel-marginDense':{
                transform: "translate(14px, 10px) scale(1) !important",
    
            },
            '& .MuiInputLabel-shrink':{
                transform: "translate(14px, -50%) scale(1) !important",
                backgroundColor: styles => 
                    styles.ControlStyle === "Style3" 
                      ? (props?.sectionStyle?.SectionBackColor ? props?.sectionStyle?.SectionBackColor : "#FFFFFF") 
                      : "#FFFFFF",
                      marginRight: styles => 
                    styles?.ControlStyle === "Style3" 
                      ?"22px":null,
                padding: "0px 4px"

            },
             '& .MuiOutlinedInput-root': {
                '&:hover': {
                    boxShadow: "0px 3px 4px rgba(0, 114, 198, 0.10)",
                    borderRadius: styles => styles?.BorderRadius ? styles.BorderRadius : '2px',
                    border: "1px #99C7E8 solid",
                    borderColor: '#99C7E8',
                    borderWidth: styles => styles?.BorderWidth 
                },
                "&.Mui-focused": {
                    // boxShadow: "0 0 5px #2274bc80 !important", 
                    borderWidth: styles => styles?.BorderWidth ? styles.BorderWidth : '1px',
                    borderStyle: 'solid',
                      borderColor: '#0072c6 !important',
                    backgroundColor: styles => styles.ControlStyle === "Style3" ? styles?.isEnable === "true" ? styles?.BackColor1 ? styles?.BackColor1 : "#FFFFFF" : "#F0F0F0" : "unset",
                    color: styles=> styles.ControlStyle === "Style3" ? styles.Fontcolor || styles.themeFontColor1 || styles.basicThemeFontColor1 + ' !important' : "none" ,
                },
                 
                borderColor: styles=> (styles.ControlStyle === "Style1" || styles.ControlStyle === "Style3") && styles?.showMandatoryMsg === false ? styles.BorderColor : styles?.showMandatoryMsg === true ? "#c32525" : "none",
                borderWidth: styles=> (styles.ControlStyle === "Style1" || styles.ControlStyle === "Style3") ? styles.BorderWidth : "none",
                borderRadius: styles=> (styles.ControlStyle === "Style1" || styles.ControlStyle === "Style3") ? styles.BorderRadius : "none",
                borderStyle:  styles=> (styles.ControlStyle === "Style1" || styles.ControlStyle === "Style3") ? "solid" : "none",
                paddingLeft: "0px !important",
                '& fieldset': {
                    // marginTop: style => `-${style?.marTop}px !important`,
                    // borderColor: styles=> styles.ControlStyle === "Style3" ? styles.BorderColor : "none",
                    // borderWidth: styles=> styles.ControlStyle === "Style3" ? styles.BorderWidth : "none",
                    // borderRadius: styles=> styles.ControlStyle === "Style3" ? styles.BorderRadius : "none",
                    // color: styles=> styles.ControlStyle === "Style3" ?  styles.color +' !important' : "none",
                    // backgroundColor: styles => styles.ControlStyle === "Style3" ? styles?.isEnable === "true" ? styles?.BackColor1 ? styles?.BackColor1 : "#FFFFFF" : "#F0F0F0" : "unset",
                    // outlineColor: styles=> styles.ControlStyle === "Style3" ? styles.BorderColor : "none",
                    // borderStyle: styles=> styles.ControlStyle === "Style3" ? 'solid' : "none",
                    top: "-6px"
                },
               
                '& .MuiInputLabel-outlined':{
                    transform : "translate(14px, 10px) scale(1) !important",
                    right:styles=>styles.ControlStyle==="Style3" && (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") ?"20px":null,
                    left:styles=>styles.ControlStyle==="Style3" && (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") ?"unset":null
                },
    
            }, 
        },
        textfieldRoot2: {
            pointerEvents: 'none',
            '&:hover': {
                '& .MuiOutlinedInput-root': {
                  //'& fieldset': {
                    boxShadow: "0px 3px 4px rgba(0, 114, 198, 0.10)",
                    borderRadius: styles => styles?.BorderRadius ? styles.BorderRadius : '2px',
                  // border: '1px solid #99C7E8',
                  borderWidth:  styles => styles?.BorderWidth ? styles.BorderWidth : '1px',
                  borderColor: '#99C7E8',
                    // borderRadius: styles => styles?.BorderRadius ? styles.BorderRadius : '2px',
                    // borderWidth:  styles => styles?.BorderWidth ? styles.BorderWidth : '1px',
                    // border: "1px #99C7E8 solid",
                // },
                },
              },
              "& .MuiIconButton-root" : {
                marginLeft: (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") ? "0px !important" :"",
                marginRight : "4px !important"
            },
            '& label.Mui-focused': {
            },    
            // '& .MuiOutlinedInput-adornedStart':{
            //     paddingLeft: "0px !important",
            // },
            '& .MuiInputAdornment-positionStart':{
                marginRight:'0px !important'
            },
            '& .MuiOutlinedInput-adornedEnd': {
                paddingRight: "0px !important"
            },
            '& .MuiOutlinedInput-input' : {
                color: styles=> styles.FontColor + "!important",
            },
            '& input:not([type="button"]):not([type="submit"]):not([readonly="readonly"]):not([type="checkbox"]).MuiInputBase-input' : {
                '&:hover': {
                  //  '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        boxShadow: "0px 3px 4px rgba(0, 114, 198, 0.10)",
                        borderRadius: styles => styles?.BorderRadius ? styles.BorderRadius : '2px',
                        //borderWidth:  styles => styles?.BorderWidth ? styles.BorderWidth : '1px',
                        border: "1px #99C7E8 solid",
                        borderColor: '#99C7E8',
                      },
                 //   },
                  },
                height: styles=> styles.height1 + ' !important' ,
                color: styles=> styles.FontColor1 + ' !important' ,
                fontSize: styles=> styles.FontSize + " !important",
                fontWeight: styles => styles.FontWeight + ' !important',
                fontStyle: styles => styles.FontStyle + ' !important',
                fontFamily: styles => styles.FontFamily + ' !important',
                paddingLeft: "8px !important"
            },
            "& .MuiInputBase-input::placeholder" : {
                background: "none !important",
                opacity: "1 !important",
                color: "#606060 !important",
                fontSize: styles=> styles.FontSize + " !important",
                fontFamily: styles => styles.FontFamily + ' !important',
            },
           '& .MuiInput-underline':{
              borderTop : 'none !important',
              borderLeft : 'none !important',
              borderRight : 'none !important',
              borderBottomColor: styles=>styles.BorderColor,
              borderBottomWidth: styles=>styles.BorderWidth,
              borderBottomLeftRadius: (styles) => 
          styles?.ControlStyle === "Style2" ? "none !important" : styles.BorderRadius,
        borderBottomRightRadius: (styles) => 
          styles?.ControlStyle === "Style2" ? "none !important" : styles.BorderRadius,
              borderBottomStyle: 'solid'
            },
            '& .MuiInput-underline:before':{
                border:"none",
              },
            //   '& .MuiOutlinedInput-root': {
            //     "& fieldset": {
            //         marginLeft:"0px !important",
            //     }
            // },
              '& .MuiInput-underline:hover':{
                borderBottom: "1px solid #99C7E8 !important",
                borderBottomStyle: "none",
                boxShadow: "0px 3px 4px rgba(0, 114, 198, 0.10) !important",
                },
                '& .MuiInput-underline:hover:not(.Mui-disabled):before':{
                    border: "none",
                },
            '& .MuiInputLabel-outlined':{
                right:styles=>styles.ControlStyle==="Style3" && (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") ?"20px":null,
                left:styles=>styles.ControlStyle==="Style3" && (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") ?"unset":null
            },
            '& .MuiInputLabel-shrink':{
                transform: "translate(14px, -50%) scale(1) !important",
                backgroundColor: styles => 
                    styles.ControlStyle === "Style3" 
                      ? (props?.sectionStyle?.SectionBackColor ? props?.sectionStyle?.SectionBackColor : "#FFFFFF") 
                      : "#FFFFFF",    
                      marginRight: styles => 
                    styles?.ControlStyle === "Style3" 
                      ?"22px":null,
                zIndex : 1,
                padding: "0px 4px"
            },
            '& .MuiOutlinedInput-root': {
                borderColor: styles=> styles.ControlStyle === "Style1" ? styles.BorderColor : "none",
                borderWidth: styles=> styles.ControlStyle === "Style1" ? styles.BorderWidth : "none",
                borderRadius: styles=> styles.ControlStyle === "Style1" ? styles.BorderRadius : "none",
                borderStyle:  styles=> styles.ControlStyle === "Style1" ? "solid" : "none",
                paddingLeft: "0px !important",
                '& fieldset': {
                    borderColor: styles=> styles.ControlStyle === "Style3" ? styles.BorderColor : "none",
                    borderWidth: styles=> styles.ControlStyle === "Style3" ? styles.BorderWidth : "none",
                    borderRadius: styles=> styles.ControlStyle === "Style3" ? styles.BorderRadius : "none",
                    color: styles=> styles.ControlStyle === "Style3" ?  styles.color +' !important' : "none",
                    borderStyle: styles=> styles.ControlStyle === "Style3" ? 'solid' : "none",
                    paddingLeft:"0px !important",
                     marginLeft:"0px !important",
                },
                "&.Mui-focused fieldset": {
                    // boxShadow: "0 0 5px #2274bc80 !important", 
                    borderStyle: 'solid',
                    borderColor: styles=> styles.ControlStyle === "Style3" ? styles.BorderColor + ' !important' : "none",
                    borderWidth: styles=> styles.ControlStyle === "Style3" ? styles.BorderWidth : "none",
                    borderRadius: styles=> styles.ControlStyle === "Style3" ? styles.BorderRadius : "none",
                },
                '& .MuiInputLabel-outlined':{
                    right:styles=>styles.ControlStyle==="Style3" && (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") ?"20px":null,
                    left:styles=>styles.ControlStyle==="Style3" && (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") ?"unset":null
                },
                "& .MuiInputBase-inputAdornedStart":{
                    textAlign:(styles) => styles.TextAlignment,
                    textTransform:(styles) => styles.CharacterSet,
                },
            }, 
        },
        FocusableIcon: {
            "&:focus" : {
                outline: '2px auto rgba(19,124,189,.6) !important',
            },
            marginLeft: (window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") ? "0px !important" : null
        }
      }));

      const NumberFormatCustom3 = useCallback((props) => {
        const { inputRef, data, onChange, ...other } = props;
        const MAX_VAL = 2147483648;
        const MIN_VAL = -2147483648;
        const withValueLimit = ({ value }) => {
            console.log("chalo3", props?.value, props?.data?.value, value, data)
            // data.value = value 
            return (value >= MIN_VAL && value <= MAX_VAL || value === "" || value=== "-")
        }
    
        var noPrefix;
        var  noSuffix;
    
    
        return (
          <NumberFormat
            {...other}
            onValueChange={({ value: v }) => onChange({ target: {value: v } })}
            allowNegative
            isNumericString
            isAllowed={withValueLimit}
              decimalScale={0}
    
          />
        );
    }, []);
    
    const NumberFormatCustom2 = useCallback((props) => {
        const { inputRef, data, onChange, ...other } = props;
        const MAX_VAL = 9223372036854775808;
        const MIN_VAL = -9223372036854775808;
        const withValueLimit = ({ value }) => {
            console.log("chalo2", props?.value, props?.data?.value, value, data)
            // data.value = value 
            return (value >= MIN_VAL && value <= MAX_VAL || value === "" || value=== "-")
        }
    
        var noPrefix;
        var  noSuffix;
    
        return (
          <NumberFormat
            {...other}
            onValueChange={({ value: v }) => onChange({ target: {value: v } })}
            allowNegative
            isNumericString
            isAllowed={withValueLimit}
              decimalScale={0}
    
          />
        );
    }, []);
    
    const NumberFormatCustom1 = useCallback((props) => {
        const { inputRef, data, onChange, ...other } = props;
        const withValueLimit = ({ value }) => {
            console.log("chalo1", props?.value, props?.data?.value, value, data)
            // data.value = value 
            return true
        }
        var noPrefix;
        var  noSuffix;
    
        return (
          <NumberFormat
            {...other}
            onValueChange={({ value: v }) => onChange({ target: {value: v } })}
            allowNegative
            isNumericString
            decimalScale = {data.datamapVariableType === "Float" && data?.datamapPercision !== undefined && data?.datamapPercision !== 0 ? parseInt(data.datamapPercision) : window?.allowPrecisionInText ? window?.allowPrecisionInText() : 2}
            isAllowed={withValueLimit}
    
          />
        );
    }, []);
    
    const AppContextVar = useContext(AppContext);

    const contexts = GetStateFromData(props.containerId);
    const { tempCanWidth, controlSelected,mandatoryControls1, resetProperties}  = GetState("tempCanWidth", "controlSelected","mandatoryControls1", "resetProperties");

    const {updateJson, IdPrecedence, openQuickToolFor, modeReadOrWrite, showAlertConfirmNotifications ,deleteControl ,applyChanges, formState2, device, allNonFilledMandatoryFields,imageBaseURL }=contexts.contexts;
      const [renderElem, updatedData, isEqual] = useRender(props?.data);
    if (updatedData && !isEqual)
    props.data = updatedData;
    console.log("renderElem password", renderElem, props?.data);
    const actualControlId = props.data.id;
    let mappingId = props.data["style"] && props.data["style"]["MappingId"];
    let userDefinedId = props.data["style"] && props.data["style"]["CustomId"];
    let userDefinedControlId = getSuggestedId(actualControlId, mappingId, userDefinedId, IdPrecedence);
    const activeTabIndex = getTabIndex(props?.data);
   // let mandatoryControls = mandatoryControls1 || [];
   const [mandatoryControls, setMandatoryControls] = useState([]);
       useEffect(() => { if(!props.data.value) setMandatoryControls(mandatoryControls1 || [])},[mandatoryControls1]);

    useEffect(() => {
        requestAnimationFrame(()=> {
            // if(props.data.style.AutoComplete === 'true' || props.data.style.AutoComplete === true) {
                document.getElementById(userDefinedControlId)?.setAttribute('autocomplete','off');
                document.getElementById(`${userDefinedControlId}_group`)?.setAttribute('autocomplete','off');
            // }
        })
    }, [])
    
    useEffect(() => {
        let flag = false;
        if(props?.isSubForm && !props?.data?.isSubForm) {
        props.data.isSubForm = props?.isSubForm;
        flag = true;
        }
        if(props?.buttonId && props?.data?.buttonId !== props?.buttonId) {
        props.data.buttonId = props?.buttonId;
        flag = true;
        }
        // if(flag)
        //     updatePartialJSON(props.data.id,props.data);
    },[props?.isSubForm, props?.buttonId])
    const data = props.data; 
    const defLabel =
    ((props.data.style && props.data.style.Label && props.data.style["Label"]) || props.data.style["Label"] === "")
        ? props.data.style["Label"]
        : props.data.id;
    const isArabic = window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";
    const [defaultLabel, setDefaultLabel] = useState(defLabel);
    const [isFocused, setIsFocused] = useState(false);
    const [mobileDisplay, setMobileDisplay] = useState(true);
    const [tabDisplay, setTabDisplay] = useState(true);    
    const [errorMessage, seterrorMessage] = useState();
    const [show , setShow] = useState(false);

    useEffect(() => {
        if(props?.previewmode){
            if (mandatoryControls.includes(props.data?.id)) {
                if(!showMandatoryMsg )
                    { 
                        setShowMandatoryMsg(true);
                    }    
            } else {
                if(showMandatoryMsg)
                setShowMandatoryMsg(false);
            }
        }
    }, [mandatoryControls]);

    useEffect(() => {
        if (props?.data?.style?.Mandatory === "false") {
            if (mandatoryControls.includes(props.data.id)) {
                    const newMandatoryList = mandatoryControls.filter(item => item !== props.data.id);
                    if(showMandatoryMsg){                      
                        setShowMandatoryMsg(false);
                      }
                  //  mandatoryControls = [...newMandatoryList];
                    setMandatoryControls(newMandatoryList);
            }
        }
    }, [props?.data?.style?.Mandatory]);

    useEffect(() => {
    //    console.log("setting default state@");
    if (
        ((props.data.style &&
        props.data.style.Label &&
        props.data.style["Label"]) || props?.data?.style?.["Label"] === "")
    ) {
        setDefaultLabel(props.data.style["Label"]);
      }
    }, [props.data.style["Label"]]);
    
    useEffect(() => {
        if(props?.data?.value){
            removeIdFromMandatoryControl(props?.data?.value)
            setValueOfText(props.data.value);
        }else{
          setValueOfText("");
        }
    }, [props.data.value]);

    useEffect(() => {
        if (isFocused) {
          elementRefrence.current?.focus(); // Ensure the input gets focused
        }
      }, [isFocused]);

    const [editLabel, setEditLabel] = useState(false);
    const bringEditableLabel = (event) => {
      setEditLabel(true);
    };

    const { t } = useTranslation();
    
    const elementRefrence= useRef(null);
      const startMobile = useRef();
      const endMobile= useRef();
      const startTab= useRef();
      const endTab= useRef();

      const value1_enc = useRef();
      const newAttrValue_enc = useRef();
  
      useEffect(() => {
          if (formState2 && formState2.style) {
              startMobile.current = parseInt(formState2.style?.["Breakpoint"]?.["Mobile"]?.["StartValue"]);
              endMobile.current = parseInt(formState2.style?.["Breakpoint"]?.["Mobile"]?.["EndValue"]);
              startTab.current = parseInt(formState2.style?.["Breakpoint"]?.["Tab"]?.["StartValue"]);
              endTab.current = parseInt(formState2.style?.["Breakpoint"]?.["Tab"]?.["EndValue"]);
          }
      },[formState2.style?.["Breakpoint"], formState2.style?.["Breakpoint"]?.["Mobile"], formState2.style?.["Breakpoint"]?.["Tab"]]); 
  
      useEffect(() => {
        if(props?.previewmode)
        handleDisplayProperty(props, device, setMobileDisplay, setTabDisplay, startMobile.current, endMobile.current, startTab.current, endTab.current)
      },[props?.data?.style?.["MobileVisible"], props?.data?.style?.["TabsVisible"], device, endMobile, endTab, startMobile, startTab,tempCanWidth]);
   


    const conditionalQuickToolOpening =
    props.id === openQuickToolFor ? true : false
      const { updatedComponentInFormState, removeAndUpdateComponentInFormState} =updateJson;  
    const [open, setOpen] =  useState(conditionalQuickToolOpening); 
    const[valueOfText, setValueOfText] = useState((props.data && props.data.value != null && props.data.value !== undefined)?props.data.value:"");
    const [showPassword, setShowPassword] = useState(false);
    const [showMandatoryMsg, setShowMandatoryMsg] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);
    const flag9 = useRef(0)
    const borderColorNew = useRef(props?.data?.style?.BorderColor)

    var themeData= formState2.theme;
    var labelInputALignment = "Top-Down";
    var controlThemeData = themeData?.['InputStyle'];
    var labelRatio = ""
    const style=props.data.style; 
    var texFieldJson1 = {
        'BorderColor':"#c4c4c4",
        'BorderWidth':"1px",
        'BorderRadius':"3px",
        'BorderStyle' :"solid",
        'BackColor':"#FFFFFF",
        'FontColor':"#000000",
        'FontFamily':"Open Sans",
        'FontSize':"12px",
        'FontWeight':"300",
        'CharacterSet':'initial',
        'ControlStyle' : 'Style1'
    };
    var ControlStyle = "Style1";
    var inlineStyleForLabel ={
        "wordBreak": "break-word",
    };
    const refFlag8 = useRef(0)
    console.log("openQuickTool", openQuickToolFor)
    const newOpenQuickToolFor = openQuickToolFor
    const refFlag7 = useRef(0)
    if(openQuickToolFor !== undefined && props.id === openQuickToolFor){
        refFlag8.current = 1
    }
    if(openQuickToolFor === undefined){
        refFlag8.current = 0
    }
    
    var isEnable;
      if(props.data.style.Enable === "true"){
      isEnable = "true"
      }else{
      isEnable = "false"
      }
      if(props?.data?.style?.ReadOnlyStyle === 'N') {
        props.data.style.ReadOnlyStyle = false;
      }
      if(props.previewmode && modeReadOrWrite === "r" && !props.data.style.isChangeFromAPI){
          props.data.style.Enable = "false"
          isEnable = "false"
      }

      useEffect(() => {
        if(texFieldJson1?.['ControlStyle'] ==="Style3"){
            let id1=document?.querySelector(`[id1="${props?.data?.id}"]`)
            if(id1){
                let fieldset = id1?.querySelector('.MuiOutlinedInput-notchedOutline');
        
                // Check if the fieldset element exists
                if (fieldset && texFieldJson1?.['ControlStyle'] ==="Style3") {
                  // Add your custom attribute to the fieldset element
                  fieldset.setAttribute('customCssId', props?.data?.id);
                }
            }
            
        }        
      }, [props?.data?.style?.ControlStyle, controlThemeData?.ControlStyleTextbox]);

    var basicThemeFontColor1
    if( themeData?.['BasicTheme']){
        if( themeData['BasicTheme']['FontFamily']){
            texFieldJson1['FontFamily'] = themeData['BasicTheme']['FontFamily'] ;
        }
        if( themeData['BasicTheme']['FontFamily'] === "Select" ){
            delete themeData['BasicTheme']['FontFamily'] ;
        }
        if(themeData['BasicTheme']['FontSize']){
            texFieldJson1['FontSize'] = themeData['BasicTheme']['FontSize'] ;
        }
        if(themeData['BasicTheme']['ActiveTextColor'] && isEnable === "true"){
            texFieldJson1['FontColor'] = themeData['BasicTheme']['ActiveTextColor'];
            basicThemeFontColor1 = themeData['BasicTheme']['ActiveTextColor'];
        }
    }
    if(controlThemeData){
        if(controlThemeData['ControlStyleTextbox']){
            ControlStyle = controlThemeData['ControlStyleTextbox'] ;
            texFieldJson1['ControlStyle'] = controlThemeData['ControlStyleTextbox'] ;
          }
       if(controlThemeData['BorderColor'] ){
            texFieldJson1['BorderColor'] = controlThemeData['BorderColor'];
        }
        if(controlThemeData['BorderWidth'] === "Select"){
            delete controlThemeData['BorderWidth'];
        }
        if(controlThemeData['BorderWidth'] ){
            texFieldJson1['BorderWidth'] = controlThemeData['BorderWidth'];
        }
        if(controlThemeData['BorderRadius'] === "Select"){
            delete controlThemeData['BorderRadius'];
        }
        if(controlThemeData['BorderRadius'] ){
            texFieldJson1['BorderRadius'] = controlThemeData['BorderRadius'];
        }
        if(controlThemeData['ValueFontColor']){
            texFieldJson1['FontColor'] = controlThemeData['ValueFontColor'];
        }
        if(controlThemeData && controlThemeData['ValueFontWeight']){
            texFieldJson1["FontWeight"] = controlThemeData['ValueFontWeight'] ;
            if(controlThemeData['ValueFontWeight'] ==="Regular Italic"){
              font_weight = 300;
              texFieldJson1["FontWeight"] = 300;
              font_style = "italic";
             }
          else if(controlThemeData['ValueFontWeight'] ==="Semibold"){
            font_weight = 600;
            texFieldJson1["FontWeight"] = 600;
            font_style = "normal";
            texFieldJson1["FontStyle"] = "normal";
          }
          else if(controlThemeData['ValueFontWeight']  ==="Bold"){
            font_weight = "bold";
            texFieldJson1["FontWeight"] = "bold";
            font_style = "normal";
            texFieldJson1["FontStyle"] = "normal";
          }
          else if(controlThemeData['ValueFontWeight'] ==="Regular" || controlThemeData['ValueFontWeight'] ==="Normal"){
            font_weight = 300;
            texFieldJson1["FontWeight"] = 300;
            font_style = "normal";
            texFieldJson1["FontStyle"] = "normal";
          }
          else if(controlThemeData['ValueFontWeight'] ==="Bold Italic"){
            font_weight = "bold";
            texFieldJson1["FontWeight"] = "bold";
            texFieldJson1["FontStyle"] = "italic";
            font_style = "italic";
          }
          else if(controlThemeData['ValueFontWeight'] ==="Light Italic" || controlThemeData['ValueFontWeight'] ==="italic"){
            font_weight = 100;
            texFieldJson1["FontWeight"] = 100;
            texFieldJson1["FontStyle"] = "italic";
            font_style = "italic";
          }
          else if(controlThemeData['ValueFontWeight'] ==="Semibold Italic"){
            font_weight = 600;
            texFieldJson1["FontWeight"] = 600;
            texFieldJson1["FontStyle"] = "italic";
            font_style = "italic";
          }
          else if(controlThemeData['ValueFontWeight'] ==="Light"){
            font_weight = 100;
            texFieldJson1["FontWeight"] = 100;
            texFieldJson1["FontStyle"] = "normal";
            font_style = "normal";
          }
        }
        if(controlThemeData['ValueFontSize'] === "Select"){
            delete controlThemeData['ValueFontSize'];
        }
        if(controlThemeData['ValueFontSize']){
            texFieldJson1['FontSize'] = controlThemeData['ValueFontSize'];
        }
        if(controlThemeData['ValueFontFamily'] === "Select"){
            delete controlThemeData['ValueFontFamily'];
        }
        if(controlThemeData['ValueFontFamily']){
            texFieldJson1['FontFamily'] = controlThemeData['ValueFontFamily'];
        }
        if(controlThemeData['LabelValueAlignment'] === "Top Bottom"){
            labelInputALignment = "Top-Bottom";
        }
        if(controlThemeData['LabelValueAlignment'] === "Left Right"){
            labelInputALignment = "Left-Right";
        }
        if(controlThemeData['LabelRatio'] === "ratio2"){
            labelRatio = "ratio2";
        }
        if(controlThemeData['LabelRatio'] === "ratio3"){
            labelRatio = "ratio3";
        }
        if(controlThemeData['LabelRatio'] === "ratio1"){
            labelRatio = "ratio1";
        }
        if(controlThemeData['LabelRatio'] === "ratio4"){
            labelRatio = "ratio4";
        }
    }


    if(style){
        if(style['ControlStyle']){
            ControlStyle = style['ControlStyle'] ;
            texFieldJson1['ControlStyle'] = style['ControlStyle'] ;
          }
        if(style['BorderColor'] ){
            texFieldJson1['BorderColor'] = style['BorderColor'];
        }
        if(style['BorderWidth'] === "Select"){
            delete props.data.style['BorderWidth'];
        }
        if(style['BorderWidth'] ){
            texFieldJson1['BorderWidth'] = style['BorderWidth'];
        }
        if(style['BorderRadius'] === "Select"){
            delete props.data.style['BorderRadius'];
        }
        if(style["TextAlignment"] === "Select"){
            delete props.data.style["TextAlignment"]
          }
        if(style['BorderRadius'] ){
            texFieldJson1['BorderRadius'] = style['BorderRadius'];
        }
        if(style['FontColor'] ){
            texFieldJson1['FontColor'] = style['FontColor'];
        }
        if(style["FontWeight"] === "Select"){
            delete props.data.style['FontWeight']
        }
        if(style['FontWeight']){
            texFieldJson1['FontWeight'] = style['FontWeight'];
        
            if(style["FontWeight"] ==="Regular Italic"){
              font_weight = 300;
              texFieldJson1['FontWeight'] = 300;
              texFieldJson1["FontStyle"] = "italic";
              font_style = "italic";
             }
          else if(style["FontWeight"] ==="Semibold"){
            font_weight = 600;
            texFieldJson1['FontWeight'] = 600;
            texFieldJson1["FontStyle"] = "normal";
            font_style = "normal";
          }
          else if(style["FontWeight"]  ==="Bold"){
            font_weight = "bold";
            texFieldJson1['FontWeight'] = "bold";
            texFieldJson1["FontStyle"] = "normal";
            font_style = "normal";
          }
          else if(style["FontWeight"] ==="Regular" || style["FontWeight"] ==="Normal"){
            font_weight = 300;
            texFieldJson1['FontWeight'] = 300;
            texFieldJson1["FontStyle"] = "normal";
            font_style = "normal";
          }
          else if(style["FontWeight"] ==="Bold Italic"){
            font_weight = "bold";
            texFieldJson1['FontWeight'] = "bold";
            texFieldJson1["FontStyle"] = "italic";
            font_style = "italic";
          }
          else if(style["FontWeight"] ==="Light Italic" || style["FontWeight"] ==="italic"){
            font_weight = 100;
            texFieldJson1['FontWeight'] = 100;
            texFieldJson1["FontStyle"] = "italic";
            font_style = "italic";
          }
          else if(style["FontWeight"] ==="Semibold Italic"){
            font_weight = 600;
            texFieldJson1['FontWeight'] = 600;
            texFieldJson1["FontStyle"] = "italic";
            font_style = "italic";
          }
          else if(style["FontWeight"] ==="Light"){
            font_weight = 100;
            texFieldJson1['FontWeight'] = 100;
            texFieldJson1["FontStyle"] = "normal";
            font_style = "normal";
          }
        }
        if(style['FontSize'] === "Select"){
            delete props.data.style['FontSize'];
        }
        if(style['FontSize'] ){
            texFieldJson1['FontSize'] = style['FontSize'];
        }
        if(style['FontFamily'] === "Select"){
            delete props.data.style['FontFamily'];
        }
        if(style['FontFamily']){
            texFieldJson1['FontFamily'] = style['FontFamily'];
        }
        if(style['FontStyle'] ){
            texFieldJson1['FontStyle'] = style['FontStyle'];
        }
        if(style['CharacterSet'] === "Select"){
            delete props.data.style['CharacterSet'];
        }
        if(style['CharacterSet']){
            texFieldJson1['CharacterSet'] = style['CharacterSet'];
        }
        if (style['LabelInputAlignment'] === "Select") {
            delete props.data.style['LabelInputAlignment'];
        }
        if (style['LabelInputAlignment']) {
            labelInputALignment = style['LabelInputAlignment'];
        }
        if(style['LabelRatio']){
            labelRatio = style['LabelRatio'];
        }
        if(style['LabelRatio'] === "ratio2"){
            labelRatio = "ratio2";
        }
        if(style['LabelRatio'] === "ratio3"){
            labelRatio = "ratio3";
        }
        if(style['LabelRatio'] === "ratio1"){
            labelRatio = "ratio1";
        }
        if(style['LabelRatio'] === "ratio4"){
            labelRatio = "ratio4";
        }
        if(style['LabelFontFamily'] === "Select"){
            delete props?.data?.style['LabelFontFamily']; 
         }
         if(style && style?.['LabelFontFamily']){
            inlineStyleForLabel["fontFamily"] = style?.['LabelFontFamily'];
        }
         if(style['LabelFontSize'] === "Select"){
            delete props?.data?.style['LabelFontSize']; 
         }
         if(style && style?.['LabelFontSize']){
            inlineStyleForLabel["fontSize"] = style?.['LabelFontSize'];
        }
         if(style['LabelFontWeight'] === "Select"){
            delete props?.data?.style['LabelFontWeight']; 
            delete props?.data?.style['LabelFontStyle']; 
         }
        texFieldJson1['TextAlignment'] = style['TextAlignment'];   
    }
    
    var showPasswordViewIcon = "true" ;
        if(controlThemeData){
            if(controlThemeData['ValueFontSize'])
                font_size = controlThemeData['ValueFontSize'];
            if(controlThemeData['ValueFontFamily'])
                font_family  = controlThemeData['ValueFontFamily'];
            if(controlThemeData['ValueFontColor'])
                textbox_color= controlThemeData['ValueFontColor'];
        }
        if(props.data.style &&props.data.style["FontColor"])
            textbox_color =props.data.style["FontColor"] ;
        if(props.data.style &&props.data.style["FontSize"])
            font_size = props.data.style && props.data.style["FontSize"] || props.data.style && props.data.style["LabelFontSize"];        
        if(props.data.style &&props.data.style["FontFamily"])
            font_family = props.data.style && props.data.style["FontFamily"];
        if(props.data.style &&props.data.style["BackColor"]){
            background_color = props.data.style && props.data.style["BackColor"];
        }
        if( props.data.style && props.data.style["CharacterSet"]){ 
            text_transform = props.data.style["CharacterSet"] ;
        }
        if( props.data.style && props.data.style["ShowPasswordIcon"]){ 
            showPasswordViewIcon= props.data.style["ShowPasswordIcon"] ;
        }
        if(props.data.style.IconAlignment == undefined ){
            props.data.style.IconAlignment = "Left";
         }
    var FontColor1 = props?.data?.style?.FontColor
    var themeFontColor1 = controlThemeData?.ValueFontColor
    
    var FontSize1 = props?.data?.style?.FontSize || controlThemeData?.ValueFontSize || "14px"
    var PlaceHolder = props.data.style.Placeholder
    var height1 = ((props.data.style && props.previewmode && props.data.style['ReadOnlyStyle'] && props.data.style['ReadOnlyStyle']==="true") || props.ReadOnlyStyle==="true")?'0px': props.data.style.FontSize && (parseInt(props.data.style.FontSize.replace(/\D/gm,"")) > 14) ? `${parseInt(props.data.style.FontSize.replace(/\D/gm,""))*2 + 4}px`: controlThemeData && controlThemeData["ValueFontSize"] && (parseInt(controlThemeData?.ValueFontSize.replace(/\D/gm,"")) > 14) ? `${parseInt(controlThemeData?.ValueFontSize.replace(/\D/gm,""))*2 + 4}px` : "32px";
    var height = height1.split('pt')[0];
    var marTop = 2;
    if(height > 24) {
        marTop = height - 24;
    }
    var BackColor1 = props?.data?.style?.BackColor;
    var classes = useStyles({...texFieldJson1, FontColor1, isEnable, BackColor1, basicThemeFontColor1, FontSize1, height1, PlaceHolder, showMandatoryMsg, themeFontColor1, marTop});
    var inlineStyleForText ={};
    var inlineStyleForLeftRightLabelInputALignment ={};
    var themeJsonForInput = {
        'color':"#000000",
        'font-family':"Open Sans",
        'font-size':"12px",
        'font-weight':"400",
    };
    var themeJsonForLabel ={
        'color':"#606060 !important",
        'font-family':"Open Sans",
        'font-size':"14px",
        'font-weight':"400",
        'white-space':"break-spaces"
    };
    var themeJsonForValue = {};
 
 var LabelFontSize;
if(((props.data.style && props.data.style['ReadOnlyStyle'] && props.data.style['ReadOnlyStyle']==="true") || props.ReadOnlyStyle==="true") && props.previewmode){
    inlineStyleForLabel['marginBottom']='0px !important';
}

if(themeData && themeData['BasicTheme'] && themeData['BasicTheme']['FontFamily']){
    themeJsonForLabel['font-family'] = themeData['BasicTheme']['FontFamily'] ;
    themeJsonForValue['font-family'] = themeData['BasicTheme']['FontFamily'] ;
}
if(themeData && themeData['BasicTheme'] && themeData['BasicTheme']['FontSize']){
    themeJsonForLabel['font-size'] = themeData['BasicTheme']['FontSize'] ;
    themeJsonForValue['font-size'] = themeData['BasicTheme']['FontSize'] ;
}
if(controlThemeData && controlThemeData['LabelFontFamily'] === "Select"){
    delete controlThemeData['LabelFontFamily'] ;
}
if(controlThemeData && controlThemeData['LabelFontFamily']){
    themeJsonForLabel['font-family'] = controlThemeData['LabelFontFamily'] ;
}
if(controlThemeData && controlThemeData['LabelFontSize'] === "Select"){
    delete controlThemeData['LabelFontSize'] ;
}
if(controlThemeData && controlThemeData['LabelFontSize']){
    themeJsonForLabel['font-size'] = controlThemeData['LabelFontSize'] ;
}
if(controlThemeData['LabelFontWeight']){
    themeJsonForLabel['font-weight'] = controlThemeData['LabelFontWeight'] ;

    if(controlThemeData['LabelFontWeight']==="Regular Italic"){
      themeJsonForLabel['font-weight'] = 300;
      themeJsonForLabel["font-style"] = "italic";
      inlineStyleForLabel['fontWeight'] = 300;
      inlineStyleForLabel["fontStyle"] = "italic";  
     }
  else if(controlThemeData['LabelFontWeight']==="Semibold"){
    themeJsonForLabel['font-weight'] = 600;
    themeJsonForLabel["font-style"] = "normal";
    inlineStyleForLabel['fontWeight'] = 600;
    inlineStyleForLabel["fontStyle"] = "normal";
  }
  else if(controlThemeData['LabelFontWeight'] ==="Bold"){
    themeJsonForLabel['font-weight'] = "bold";
    themeJsonForLabel["font-style"] = "normal";
    inlineStyleForLabel['fontWeight'] = "bold";
    inlineStyleForLabel["fontStyle"] = "normal";
  }
  else if(controlThemeData['LabelFontWeight']==="Regular" || controlThemeData['LabelFontWeight']==="Normal"){
    themeJsonForLabel['font-weight'] = 300;
    themeJsonForLabel["font-style"] = "normal";
    inlineStyleForLabel['fontWeight'] = 300;
    inlineStyleForLabel["fontStyle"] = "normal";
  }
  else if(controlThemeData['LabelFontWeight']==="Bold Italic"){
    themeJsonForLabel['font-weight'] = "bold";
    themeJsonForLabel["font-style"] = "italic";
    inlineStyleForLabel['fontWeight'] = "bold";
    inlineStyleForLabel["fontStyle"] = "italic";
  }
  else if(controlThemeData['LabelFontWeight']==="Light Italic" || controlThemeData['LabelFontWeight']==="italic"){
    themeJsonForLabel['font-weight'] = 100;
    themeJsonForLabel["font-style"] = "italic";
    inlineStyleForLabel['fontWeight'] = 100;
    inlineStyleForLabel["fontStyle"] = "italic";
  }
  else if(controlThemeData['LabelFontWeight']==="Semibold Italic"){
    themeJsonForLabel['font-weight'] = 600;
    themeJsonForLabel["font-style"] = "italic";
    inlineStyleForLabel['fontWeight'] = 600;
    inlineStyleForLabel["fontStyle"] = "italic";        
  }
  else if(controlThemeData['LabelFontWeight']==="Light"){
    themeJsonForLabel['font-weight'] = 100;
    themeJsonForLabel["font-style"] = "normal";
    inlineStyleForLabel['fontWeight'] = 100;
    inlineStyleForLabel["fontStyle"] = "normal";
  }
}
if(style['LabelFontWeight'] === "Select"){
    delete props.data.style["LabelFontWeight"]
}
if(style['LabelFontWeight']){
    inlineStyleForLabel['fontWeight'] = style?.LabelFontWeight;
    inlineStyleForLabel["fontStyle"] = style?.LabelFontStyle; 
}
if(controlThemeData && controlThemeData['LabelFontColor']){
    themeJsonForLabel['color'] = controlThemeData['LabelFontColor'] ;
}
if(style && style?.['LabelFontColor']){
    inlineStyleForLabel["color"] = style?.['LabelFontColor'];
}
if(controlThemeData && controlThemeData['LabelBackgroundColor']){
    themeJsonForLabel['background-color'] = controlThemeData['LabelBackgroundColor'] ;
}
if(controlThemeData && controlThemeData['LabelFontFamily']){
    themeJsonForValue['font-family'] = controlThemeData['LabelFontFamily'] ;
}
if(controlThemeData && controlThemeData['LabelFontSize']){
    themeJsonForValue['font-size'] = controlThemeData['LabelFontSize'] ;
}
if(controlThemeData && controlThemeData['LabelFontWeight']){
    themeJsonForValue['font-weight'] = controlThemeData['LabelFontWeight'] ;
}
if(controlThemeData && controlThemeData['LabelFontColor']){
    themeJsonForValue['color'] = controlThemeData['LabelFontColor'] ;
}
if(controlThemeData && controlThemeData['BorderWidth']){
    themeJsonForInput['border-width']= controlThemeData['BorderWidth'] ;
}
if(controlThemeData&& controlThemeData['BorderColor']){
    themeJsonForInput['border-color']= controlThemeData['BorderColor'] ;
}
if(controlThemeData && controlThemeData['BorderRadius']){
    themeJsonForInput['border-radius']= controlThemeData['BorderRadius'] ;
}
if(controlThemeData['LabelValueAlignment'] === "Top Bottom"){
    labelInputALignment = "Top-Bottom";
}
if(controlThemeData['LabelValueAlignment'] === "Left Right"){
    labelInputALignment = "Left-Right";
}
//  if(props.data.style!==null && props.data.style!==undefined){
//     Object.keys(props.data.style).forEach(keyName=>{
//     if(props.data.style[keyName]!==null && props.data.style[keyName]!==undefined){
//         if(keyName.includes('Label'))
//         {
//             inlineStyleForLabel[CSSKeys[keyName]]=props.data.style[keyName];
//         }
//     }
//  })}
 
 var themeStyle = {
     'textbox_labelStyle1' : themeJsonForLabel,
     'inputStyle1' : themeJsonForInput,
     'valueStyle1' : themeJsonForValue
 }

    
//    var jsonForlabel = {};
//    var jsonForValue = {};

//    if(ThemeJSON.textbox !== null)
//     {
//      Object.keys(ThemeJSON.textbox).forEach(keyName=>{
//          if(keyName.includes('Label')){
//              jsonForlabel[keyName]=ThemeJSON.textbox[keyName];
//          }else{
//             jsonForValue[keyName]=ThemeJSON.textbox[keyName];
//          }
//      })
//     }

//      if(props && props.data && props.data.style){
//         Object.keys(props.data.style).forEach(keyName=>{
//             if(keyName === 'LabelFontSize' || keyName === 'LabelFontWeight' || keyName === 'LabelFontFamily'){
//                 jsonForlabel[keyName]=props.data.style[keyName];
//             }else{
//                jsonForValue[keyName]=props.data.style[keyName];
//             }
//         })
//      }

    //  const preparedStyle1 = CSSPreparation1(jsonForValue);
    //  const preparedStyle2 = CSSPreparation1(jsonForlabel);
    
     
    //  var styleSheet2 = StyleSheet.create({
    //     styling2: preparedStyle2
    // });
    var mandatoryElem=<></>;
    if(props.data.style && props.data.style["Mandatory"]!==undefined && props.data.style["Mandatory"]!==null &&props.data.style.placeholder !== null &&props.data.style["Mandatory"]==="true"){
        mandatoryElem=<>
            <span style={{color:"#C32525",fontWeight:"400",fontSize: "12px"}}  aria-label="Required">*</span>
            
        </>
    }

        var iconFile;
        var binaryData = [];
        if(props.data.style && props.data.style.iconFile!==undefined && props.data.style.iconName!==null){
            iconFile=props.data.style.iconFile;
            binaryData.push(props.data.style.iconFile);
        }
        const iconStyle={height:"14px", width:"15px",verticalAlign:"baseline", marginRight:"6px"}  

        var variantStyle="outlined";

        if(controlThemeData && controlThemeData?.["ControlStyleTextbox"]==='Style1' ){
            variantStyle="outlined";
        }
        else if(controlThemeData && controlThemeData?.["ControlStyleTextbox"]==='Style2'){
            variantStyle="standard";
        } 
        if(props.data.style && props.data.style.ControlStyle!==undefined && props.data.style.ControlStyle!==null){
            
            if(props.data.style["ControlStyle"]==='Style1'){
                variantStyle="outlined";
            } 
            if(props.data.style["ControlStyle"]==='Style2'){
                var variantStyle2;
                variantStyle="standard";
            }
        }
              

        var textbox_color ;
        var font_size ;       
        var font_family 
        var background_color  ;
        var font_weight ;
        var font_style ;
        var text_transform = 'initial';
        if(textbox_color!==undefined && textbox_color!==null && textbox_color!==''){

        } else {
            textbox_color="#000000";
        }
        
        if(font_size!==undefined && font_size!==null && font_size!==''){
        } else {
            font_size="12px";
        }


        // var iconForTooltip;
        // iconForTooltip=<InfoOutlinedIcon fontSize="small" style={{width: LabelFontSize,height:LabelFontSize, verticalAlign: 'middle'}} />
        
        if(font_family !==undefined && font_family !==null && font_family !==''){

        } else {
            font_family="Open Sans";
        }


       
        if(font_weight !==undefined && font_weight !==null && font_weight !==''){

        } else {
            font_weight="normal";
        }

        if(font_style !==undefined && font_style !==null && font_style !==''){

        } else {
            font_style="normal";
        }

        if(background_color !==undefined && background_color !==null && background_color !==''){

        } else {
            background_color="#FFFFFF";
        }
        const controlSpacing = themeData?.['Control Spacing'] || {};
        var padding_left = props.data.style && props.data.style["SpacingLeft"];        
        var padding_right = props.data.style && props.data.style["SpacingRight"];
        var padding_top = props.data.style && props.data.style["SpacingTop"];
        var padding_bottom = props.data.style && props.data.style["SpacingBottom"];
          
        var max_length = '' ;
          NumberFormatCustom1.propTypes = {
            name: PropTypes.string.isRequired,
            onChange: PropTypes.func.isRequired,
          };
          NumberFormatCustom2.propTypes = {
            name: PropTypes.string.isRequired,
            onChange: PropTypes.func.isRequired,
          };
          NumberFormatCustom3.propTypes = {
            name: PropTypes.string.isRequired,
            onChange: PropTypes.func.isRequired,
          };

      var inputStyleForStyle3={  
             style:{     
                color : textbox_color,
                //fontSize: font_size,
                fontFamily: font_family,
                fontWeight: font_weight,
                fontStyle : font_style,
                backgroundColor: isEnable === "false" ? "#F0F0F0" : background_color,
                //height:"23pt",
                height: props?.data?.style?.FontSize ? `${parseInt(props?.data?.style?.FontSize?.replace(/\D/gm, ""))*2 + 4}px` : controlThemeData?.ValueFontSize && (parseInt(controlThemeData?.ValueFontSize?.replace(/\D/gm, "")) > 14) ? `${parseInt(controlThemeData?.ValueFontSize?.replace(/\D/gm, ""))*2 + 4}px` : "23.5pt",
                textTransform: text_transform 
                       
            },
            startAdornment: (
                <InputAdornment position='start'>
                 {props?.data?.style?.iconFile && props?.data?.style?.IconAlignment === 'Left' &&
                          <>
                          <img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`}  style={{width:font_size, height:font_size, margin: "0px 8px"}}/>
                          </>
                  }
                </InputAdornment>
              ),
            endAdornment: (
                <InputAdornment position="end">
                    { showPasswordViewIcon ==  "true" &&
                     <IconButton style={{zIndex:1, backgroundColor:"initial"}} tabIndex= {isEnable === "false" ? -1 : activeTabIndex} aria-label={"password visibility"}  onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      classes={{
                        root: classes.FocusableIcon
                      }} 
                      >
                         {showPassword ? <Visibility fontSize="small"/> : <VisibilityOff fontSize="small"/>}
                     </IconButton> 
                    }
                    {props?.data?.style?.iconFile && props?.data?.style?.IconAlignment === 'Right' &&
                        <>
                        <img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`}  style={{width:font_size, height:font_size, marginLeft: "-4px", marginRight: "8px", marginTop: "0px", marginBottom: "0px"}}/>
                        </>
                    }
                </InputAdornment> 
             ),
            control_id:userDefinedControlId,   
            id1:  props?.data?.id,       
            customCssId:texFieldJson1?.['ControlStyle'] !== "Style3" ? props?.data?.id : null
        }

        var inputStyleForFloatVarMapping3={  
            style:{     
               color : textbox_color,
               fontSize: font_size,
               fontFamily: font_family,
               fontWeight: font_weight,
               fontStyle : font_style,
               backgroundColor: isEnable === "false" ? "#F0F0F0" : background_color,
               height:"23pt",
               textTransform: text_transform 
                      
           },
           startAdornment: (
            <InputAdornment position='start'>
             {props?.data?.style?.iconFile && props?.data?.style?.IconAlignment === 'Left' &&
                      <>
                      <img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`}  style={{width:font_size, height:font_size, margin: "0px 8px"}}/>
                      </>
              }
            </InputAdornment>
          ),
           endAdornment: (
               <InputAdornment position="end">
                   { showPasswordViewIcon ==  "true" &&
                   <IconButton style={{zIndex:1, backgroundColor:"initial"}} tabIndex= {isEnable === "false" ? -1 : activeTabIndex} aria-label={"password visibility"}  onClick={handleClickShowPassword}
                    classes={{
                        root: classes.FocusableIcon
                    }} 
                     >
                        {showPassword ? <Visibility fontSize="small"/> : <VisibilityOff fontSize="small"/>}
                    </IconButton> 
                   }
                   {props?.data?.style?.iconFile && props?.data?.style?.IconAlignment === 'Right' &&
                        <>
                        <img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`}  style={{width:font_size, height:font_size, marginLeft: "-4px", marginRight: "8px", marginTop: "0px", marginBottom: "0px"}}/>
                        </>
                    }
               </InputAdornment> 
            ),
           control_id:userDefinedControlId, 
           inputComponent: NumberFormatCustom1, 
           id1:  props?.data?.id,           
          customCssId:texFieldJson1?.['ControlStyle'] !== "Style3" ? props?.data?.id : null
       }

       var inputStyleForLongVarMapping3={  
        style:{     
           color : textbox_color,
           fontSize: font_size,
           fontFamily: font_family,
           fontWeight: font_weight,
           fontStyle : font_style,
           backgroundColor: isEnable === "false" ? "#F0F0F0" : background_color,
           height:"23pt",
           marginTop:"0.5px",
           textTransform: text_transform 
                  
       },
       startAdornment: (
        <InputAdornment position='start'>
         {props?.data?.style?.iconFile && props?.data?.style?.IconAlignment === 'Left' &&
                  <>
                  <img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`}  style={{width:font_size, height:font_size, margin: "0px 8px"}}/>
                  </>
          }
        </InputAdornment>
      ),
       endAdornment: (
           <InputAdornment position="end">
               { showPasswordViewIcon ==  "true" &&
                <IconButton style={{zIndex:1, backgroundColor:"initial"}} tabIndex= {isEnable === "false" ? -1 : activeTabIndex} aria-label= {"password visibility"}  onClick={handleClickShowPassword}
                    classes={{
                        root: classes.FocusableIcon
                    }} 
                >
                    {showPassword ? <Visibility fontSize="small"/> : <VisibilityOff fontSize="small"/>}
                </IconButton> 
               }
               {props?.data?.style?.iconFile && props?.data?.style?.IconAlignment === 'Right' &&
                        <>
                        <img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`}  style={{width:font_size, height:font_size, marginLeft: "-4px", marginRight: "8px", marginTop: "0px", marginBottom: "0px"}}/>
                        </>
                    }
           </InputAdornment> 
        ),
       control_id:userDefinedControlId, 
       inputComponent: NumberFormatCustom2,
   }

   var inputStyleForIntegerVarMapping3={  
    style:{     
       color : textbox_color,
       fontSize: font_size,
       fontFamily: font_family,
       fontWeight: font_weight,
       fontStyle : font_style,
       backgroundColor: isEnable === "false" ? "#F0F0F0" : background_color,
       height:"23pt",
       textTransform: text_transform 
              
   },
   startAdornment: (
    <InputAdornment position='start'>
     {props?.data?.style?.iconFile && props?.data?.style?.IconAlignment === 'Left' &&
              <>
              <img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`}  style={{width:font_size, height:font_size, margin: "0px 8px"}}/>
              </>
      }
    </InputAdornment>
  ),
   endAdornment: (
       <InputAdornment position="end">
           { showPasswordViewIcon ==  "true" &&
            <IconButton style={{zIndex:1, backgroundColor:"initial"}} tabIndex= {isEnable === "false" ? -1 : activeTabIndex} aria-label={"password visibility"}  onClick={handleClickShowPassword}
                    classes={{
                        root: classes.FocusableIcon
                    }} 
              >
                {showPassword ? <Visibility fontSize="small"/> : <VisibilityOff fontSize="small"/>}
            </IconButton> 
           }
           {props?.data?.style?.iconFile && props?.data?.style?.IconAlignment === 'Right' &&
                        <>
                        <img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`}  style={{width:font_size, height:font_size, marginLeft: "-4px", marginRight: "8px", marginTop: "0px", marginBottom: "0px"}}/>
                        </>
                    }
       </InputAdornment> 
    ),
   control_id:userDefinedControlId, 
   inputComponent: NumberFormatCustom3,   
   id1:  props?.data?.id, 
  customCssId:texFieldJson1?.['ControlStyle'] !== "Style3" ? props?.data?.id : null
}
        var inputStyle={  
        style:{        
            color : textbox_color,
            fontFamily: font_family,
            fontWeight: font_weight,
            fontStyle : font_style,
            backgroundColor: isEnable === "false" ? "#F0F0F0" : background_color,
            height:((props.data.style && props.data.style['ReadOnlyStyle'] && props.data.style['ReadOnlyStyle']==="true") || props.ReadOnlyStyle==="true") && props.previewmode?'0px':props.data.style && props.data.style.FontSize && (parseInt(props.data.style.FontSize.replace(/\D/gm,"")) > 14) ? `${parseInt(props.data.style.FontSize.replace(/\D/gm,""))*2 + 4}px` : controlThemeData && controlThemeData["ValueFontSize"] && (parseInt(controlThemeData?.ValueFontSize.replace(/\D/gm, "")) > 14) ? `${parseInt(controlThemeData?.ValueFontSize.replace(/\D/gm, ""))*2 + 4}px` : "24pt",
            padding:((props.data.style && props.data.style['ReadOnlyStyle'] && props.data.style['ReadOnlyStyle']==="true") || props.ReadOnlyStyle==="true") && props.previewmode?'0px':"4.5px !important",
            textTransform: text_transform ,
            marginTop: props.data?.style?.labelInputALignment !== "Left-Right" ? "0px" : "0.5px"
            
        },
            startAdornment: (
              <InputAdornment position='start'>
               {props?.data?.style?.iconFile && props?.data?.style?.IconAlignment === 'Left' &&
                        <>
                        <img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`}  style={{width:font_size, height:font_size, margin: "0px 8px"}}/>
                        </>
                }
              </InputAdornment>
            ),
            endAdornment: (
                 <InputAdornment position="end">
                    { showPasswordViewIcon ==  "true" &&
                        <IconButton style={{zIndex:1, backgroundColor:"initial"}} tabIndex= {isEnable === "false" ? -1 : activeTabIndex} aria-label={"password visibility"}  onClick={handleClickShowPassword}
                        classes={{
                            root: classes.FocusableIcon
                        }} 
                          >
                            {showPassword ? <Visibility fontSize="small"/> : <VisibilityOff fontSize="small"/>}
                        </IconButton> 
                    }
                    {props?.data?.style?.iconFile && props?.data?.style?.IconAlignment === 'Right' &&
                        <>
                        <img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`}  style={{width:font_size, height:font_size, marginLeft: "-4px", marginRight: "8px", marginTop: "0px", marginBottom: "0px"}}/>
                        </>
                    }
                    </InputAdornment> 
              ), 
            control_id:userDefinedControlId,      
            id1:  props?.data?.id,        
            customCssId:texFieldJson1?.['ControlStyle'] !== "Style3" ? props?.data?.id : null
        };

        var inputStyleForFloatVarMapping={  
        style:{        
            color : textbox_color,
            fontFamily: font_family,
            fontWeight: font_weight,
            fontStyle : font_style,
            backgroundColor: isEnable === "false" ? "#F0F0F0" : background_color,
            height:((props.data.style && props.data.style['ReadOnlyStyle'] && props.data.style['ReadOnlyStyle']==="true") || props.ReadOnlyStyle==="true") && props.previewmode?'0px':props.data.style && props.data.style.FontSize && (parseInt(props.data.style.FontSize.replace(/\D/gm,"")) > 14) ? `${parseInt(props.data.style.FontSize.replace(/\D/gm,""))*2 + 4}px` : controlThemeData && controlThemeData["ValueFontSize"] && (parseInt(controlThemeData?.ValueFontSize.replace(/\D/gm, "")) > 14) ? `${parseInt(controlThemeData?.ValueFontSize.replace(/\D/gm, ""))*2 + 4}px` : "24pt",
            padding:((props.data.style && props.data.style['ReadOnlyStyle'] && props.data.style['ReadOnlyStyle']==="true") || props.ReadOnlyStyle==="true") && props.previewmode?'0px':"4.5px !important",
            textTransform: text_transform 
            
        },
            startAdornment: (
              <InputAdornment position='start'>
               {props?.data?.style?.iconFile && props?.data?.style?.IconAlignment === 'Left' &&
                        <>
                        <img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`}  style={{width:font_size, height:font_size, margin: "0px 8px"}}/>
                        {/* &nbsp;&nbsp; */}
                        </>
                }
              </InputAdornment>
            ),
            endAdornment: (
                 <InputAdornment position="end">
                    { showPasswordViewIcon ==  "true" &&
                        <IconButton style={{zIndex:1, backgroundColor:"initial"}} tabIndex= {isEnable === "false" ? -1 : activeTabIndex} aria-label={ "password visibility"}  onClick={handleClickShowPassword}
                        classes={{
                            root: classes.FocusableIcon
                        }} 
                          >
                            {showPassword ? <Visibility fontSize="small"/> : <VisibilityOff fontSize="small"/>}
                        </IconButton> 
                    }
                    {props?.data?.style?.iconFile && props?.data?.style?.IconAlignment === 'Right' &&
                        <>
                        <img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`}  style={{width:font_size, height:font_size, marginLeft: "-4px", marginRight: "8px", marginTop: "0px", marginBottom: "0px"}}/>
                        </>
                    }
                    </InputAdornment> 
              ), 
            inputComponent: NumberFormatCustom1,
            control_id:userDefinedControlId,
            id1:  props?.data?.id, 
            customCssId:texFieldJson1?.['ControlStyle'] !== "Style3" ? props?.data?.id : null
        };

        var inputStyleForLongVarMapping={  
        style:{        
            color : textbox_color,
            fontFamily: font_family,
            fontWeight: font_weight,
            fontStyle : font_style,
            backgroundColor: isEnable === "false" ? "#F0F0F0" : background_color, 
            height:((props.data.style && props.data.style['ReadOnlyStyle'] && props.data.style['ReadOnlyStyle']==="true") || props.ReadOnlyStyle==="true") && props.previewmode?'0px':props.data.style && props.data.style.FontSize && (parseInt(props.data.style.FontSize.replace(/\D/gm,"")) > 14) ? `${parseInt(props.data.style.FontSize.replace(/\D/gm,""))*2 + 4}px` : controlThemeData && controlThemeData["ValueFontSize"] && (parseInt(controlThemeData?.ValueFontSize.replace(/\D/gm, "")) > 14) ? `${parseInt(controlThemeData?.ValueFontSize.replace(/\D/gm, ""))*2 + 4}px` : "24pt",
            padding:((props.data.style && props.data.style['ReadOnlyStyle'] && props.data.style['ReadOnlyStyle']==="true") || props.ReadOnlyStyle==="true") && props.previewmode?'0px':"4.5px !important",
            textTransform: text_transform 
            
        },
            startAdornment: (
              <InputAdornment position='start'>
               {props?.data?.style?.iconFile && props?.data?.style?.IconAlignment === 'Left' &&
                        <>
                        <img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`}  style={{width:font_size, height:font_size, margin: "0px 8px"}}/>
                        </>
                }
              </InputAdornment>
            ),
            endAdornment: (
                 <InputAdornment position="end">
                    { showPasswordViewIcon ==  "true" &&
                       <IconButton style={{zIndex:1, backgroundColor:"initial"}} tabIndex= {isEnable === "false" ? -1 : activeTabIndex} aria-label={"toggle password visibility"}  onClick={handleClickShowPassword}
                        classes={{
                            root: classes.FocusableIcon
                        }} 
                         >
                            {showPassword ? <Visibility fontSize="small"/> : <VisibilityOff fontSize="small"/>}
                        </IconButton> 
                    }
                    {props?.data?.style?.iconFile && props?.data?.style?.IconAlignment === 'Right' &&
                        <>
                        <img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`}  style={{width:font_size, height:font_size, marginLeft: "-4px", marginRight: "8px", marginTop: "0px", marginBottom: "0px"}}/>
                        </>
                    }
                    </InputAdornment> 
              ), 
            control_id:userDefinedControlId,
            id1:  props?.data?.id, 
            customCssId:texFieldJson1?.['ControlStyle'] !== "Style3" ? props?.data?.id : null,
            inputComponent: NumberFormatCustom2,
        };

        var inputStyleForIntegerVarMapping={  
        style:{        
            color : textbox_color,
            fontFamily: font_family,
            fontWeight: font_weight,
            fontStyle : font_style,
            backgroundColor: isEnable === "false" ? "#F0F0F0" : background_color,
            height:((props.data.style && props.data.style['ReadOnlyStyle'] && props.data.style['ReadOnlyStyle']==="true") || props.ReadOnlyStyle==="true") && props.previewmode?'0px':props.data.style && props.data.style.FontSize && (parseInt(props.data.style.FontSize.replace(/\D/gm,"")) > 14) ? `${parseInt(props.data.style.FontSize.replace(/\D/gm,""))*2 + 4}px` : controlThemeData && controlThemeData["ValueFontSize"] && (parseInt(controlThemeData?.ValueFontSize.replace(/\D/gm, "")) > 14) ? `${parseInt(controlThemeData?.ValueFontSize.replace(/\D/gm, ""))*2 + 4}px` : "24pt",
            padding:((props.data.style && props.data.style['ReadOnlyStyle'] && props.data.style['ReadOnlyStyle']==="true") || props.ReadOnlyStyle==="true") && props.previewmode?'0px':"4.5px !important",
            textTransform: text_transform 
            
        },
            startAdornment: (
              <InputAdornment position='start'>
               {props?.data?.style?.iconFile && props?.data?.style?.IconAlignment === 'Left' &&
                        <>
                        <img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`}  style={{width:font_size, height:font_size, margin: "0px 8px"}}/>
                        </>
                }
              </InputAdornment>
            ),
            endAdornment: (
                 <InputAdornment position="end">
                    { showPasswordViewIcon ==  "true" &&
                        <IconButton style={{zIndex:1, backgroundColor:"initial"}} tabIndex= {isEnable === "false" ? -1 : activeTabIndex} aria-label={ "toggle password visibility"}  onClick={handleClickShowPassword}
                        classes={{
                            root: classes.FocusableIcon
                        }} 
                          >
                            {showPassword ? <Visibility fontSize="small"/> : <VisibilityOff fontSize="small"/>}
                        </IconButton> 
                    }
                    {props?.data?.style?.iconFile && props?.data?.style?.IconAlignment === 'Right' &&
                        <>
                        <img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`}  style={{width:font_size, height:font_size, marginLeft: "-4px", marginRight: "8px", marginTop: "0px", marginBottom: "0px"}}/>
                        </>
                    }
                    </InputAdornment> 
              ), 
            control_id:userDefinedControlId, 
            inputComponent: NumberFormatCustom3,
            id1:  props?.data?.id,             
            customCssId:texFieldJson1?.['ControlStyle'] !== "Style3" ? props?.data?.id : null
        };
    
       

        var border_width = '1px' ;
        var border_color = '#ced4da' ;
        var border_radius = '4px' ;  
        if(controlThemeData && controlThemeData['BorderWidth']){
            border_width = controlThemeData['BorderWidth'] ;
        }
        if(controlThemeData&& controlThemeData['BorderColor']){
            border_color = controlThemeData['BorderColor'] ;
        }
        if(controlThemeData && controlThemeData['BorderRadius']){
            border_radius = controlThemeData['BorderRadius'] ;
        }
        if(props.data && props.data.style && props.data.style["BorderWidth"]){
            border_width = props.data.style["BorderWidth"] ;
        } 
        if(props.data && props.data.style && props.data.style["BorderColor"]){
            border_color = props.data.style["BorderColor"] ;
        }
        if(props.data && props.data.style && props.data.style["BorderRadius"]){
            border_radius = props.data.style["BorderRadius"] ;
        }
        const useStylesBootstrap = makeStyles((theme) => ({
            arrow: {
              color: theme.palette.common.black,
            },
            tooltip: {
              backgroundColor: theme.palette.common.black,
            },
          }));

        function BootstrapTooltip(props) {
            const classes = useStylesBootstrap();
      
            return <Tooltip arrow classes={classes} {...props} />;
          }


        var CustomIcon = <>
            </>;

function removeIdFromMandatoryControl(value){
    if(mandatoryControls.includes(props.data.id)){
        if(value.length > 0){
            const newMandatoryList = mandatoryControls.filter((item)=>item !== props.data.id)
            if(showMandatoryMsg){                      
                setShowMandatoryMsg(false);
              }
            // mandatoryControls = [...newMandatoryList];
            setMandatoryControls([...newMandatoryList])
        }
    }
}

function handleText(e){


    const emojiRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g; // Regular expression for matching emojis
    const strippedValue = e?.target?.value?.replace(emojiRegex, ""); // Remove emojis from the value
    e.target.value = strippedValue;
    if(!window.isFormModified()) {
        window.setFormMoified(true);
    }
     if(e.target.value !== null &&  e.target.value !== "" && e.target.value !== undefined ){
        setShow(true);
    } 
    else{
        setShow(false)
    }

    if(props?.data?.datamapVariableType !== "Float" || props?.data?.datamapVariableType !== "Integer" || props?.data?.datamapVariableType !== "Long"){
        setValueOfText(e.target.value);
        removeIdFromMandatoryControl(e.target.value)
        }
   
}

async function hadleValueChange(e)
{ 
    setIsFocused(false);
    const emojiRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g; // Regular expression for matching emojis
    const strippedValue = e?.target?.value?.replace(emojiRegex, ""); // Remove emojis from the value
    e.target.value = strippedValue;
    if(flag9.current === 0){
        borderColorNew.current = props?.data?.style?.BorderColor
       }
      var value1 = e?.target?.value
      var floatingValue;
      var floatingLength;
      var finalFloatingLength;
      var precisionValue;
      var flag33 = 0;
      if(props?.data?.datamapVariableLength && props?.data?.datamapVariableLength !== 0 && props?.data?.datamapVariableType === "Float"){
          floatingLength = props?.data?.datamapVariableLength
      }
      else if(props?.data?.datamapVariableType === "Float" && (props?.data?.datamapVariableLength === undefined || props?.data?.datamapVariableLength === 0)){
          floatingLength = 15
      }
      if(props?.data?.datamapPercision && parseInt(props?.data?.datamapPercision) !== 0 && props?.data?.datamapVariableType === "Float"){
        precisionValue = props?.data?.datamapPercision
    }
    else if(props?.data?.datamapVariableType === "Float" && (props?.data?.datamapPercision === undefined || parseInt(props?.data?.datamapPercision) === 0)){
        precisionValue = window?.allowPrecisionInText ? window?.allowPrecisionInText() : 2
    }
    finalFloatingLength = parseInt(floatingLength) - parseInt(precisionValue)
    if( props.partOfListview === true )
    {
        props.handleRowData(e.target.value);
    }

    if((props?.data?.datamapVariableType === "Float" || props?.data?.datamapVariableType === "Integer" || props?.data?.datamapVariableType === "Long")){
        setValueOfText(e.target.value);
        removeIdFromMandatoryControl(e.target.value)
      }

      if(props?.data?.datamapVariableType === "Float"){
        value1 = e.target.value.replace(/[^0-9.-]/g, "");
        if(e?.target?.value?.includes(".")){
            var x = e?.target?.value?.split(".")
            floatingValue = x[0]?.replace(/[^0-9]/g, "");
        }
        else{
            floatingValue = e.target.value.replace(/[^0-9]/g, "");
        }
        console.log("bb")
        if(floatingValue.length > finalFloatingLength){
            flag33 = 1
            seterrorMessage(`Entered value is out of range, datamapVariableLength:${floatingLength} precisionValue:${precisionValue}`)
            props.data.style.BorderColor="red";
            flag9.current = 1
            if(props.data.style["Mandatory"] === "true"){
                // setMandatoryControls( 
                //     [...mandatoryControls, props?.id]
                // )
            }
        }
        else{
            flag33 = 0
            if(borderColorNew.current === undefined){
                props.data.style.BorderColor= "#C4C4C4";
                console.log("changed Border Color to undefined")
                seterrorMessage(null)
                if(props.data.style["Mandatory"] === "true"){
                    removeIdFromMandatoryControl(e.target.value)
                }
            }
            else if(borderColorNew.current !== undefined){
                props.data.style.BorderColor= borderColorNew.current;
                console.log("changed Border Color to green")
                seterrorMessage(null)
                if(props.data.style["Mandatory"] === "true"){
                    removeIdFromMandatoryControl(e.target.value)
                }
            }
        }
    }

    if (value1 != props.data.value && flag33 === 0)
    {
        var newValue=e.target.value;
                var flag21 = 0
                var newAttrValue

                if((props?.data?.datamapVariableType === "Float" || props?.data?.datamapVariableType === "Integer" || props?.data?.datamapVariableType === "Long")){
                  flag21 = 1
                  newAttrValue = e.target.value.replace(/[^0-9-.]/g,'')
                } 
                if(props?.data?.style?.CharacterSet === "Uppercase"){
                    if(flag21 === 0){
                        value1 = value1?.toUpperCase()
                    }
                    else{
                        newAttrValue = newAttrValue?.toUpperCase();
                    }
                }

         
        function get_encr_val(val){
            return encrypt(val);
        }        

        value1_enc.current = await get_encr_val(value1);

        newAttrValue_enc.current = await get_encr_val(newAttrValue);
        
        var jsonToSend={
            "attrValue": (flag21 === 0 && value1 === "") || (flag21 === 1 && newAttrValue === "") ? "" : flag21 === 0 ?  value1_enc.current : newAttrValue_enc.current,
            "attrType":"password",
            "attrName": props.data.dataclass || userDefinedId || props.data.id
        };
        props.data.value=newValue;
        updateValue(props.data?.id,newValue, props.containerId,props?.data);
        sendRequestToUpdateValue(jsonToSend, props?.data?.frameIndex).then((response)=>{
            if(response && response.data && response.data.status === "-2"){
                showAlertConfirmNotifications({
                  open: true,
                  showConfirm: "showNotification",
                  alertType: "error",
                  alertContentKey: "INVALID_DATA_MESSAGE",
                })
              }
              if(window.postChangeEventHandler && response?.data?.responseData){
                window.postChangeEventHandler(props.data.dataclass || userDefinedId || props.data.id, response?.data?.responseData)
                // if(functions?.render){
                    functions?.updateJSON()
                //   }
              }
              if(response?.data?.APIData){
                renderExecuteServerEventAPIData({outputArray:response?.data?.APIData,sync: true, renderFlag: true}, props?.containerId);
                // if(functions?.render){
                    functions?.updateJSON()
                // }
              }
              if(props.data && props.data.event && props.data.event.Events && props.data.event.Events.Change){
                var element=elementRefrence.current;
                element=element.getElementsByTagName("input")[0];
                e["type"] = "change"
                triggerEventCalls(e,{id:props?.data?.id},props.data.event,props.data.elem_type);
            }
            if(props.data && props.data.event && props.data.event.Events && props.data.event.Events.LostFocus)
    {
        var element=elementRefrence.current;
    element=element.getElementsByTagName("input")[0];
    e["type"] = "blur"
    triggerEventCalls(e,{id:props?.data?.id},props.data.event,props.data.elem_type);
    }
            })
        
    }
    else if( value1 == props.data.value && flag33 === 0 )
    {
        var newValue=e.target.value;
                var flag21 = 0
                var newAttrValue

                if((props?.data?.datamapVariableType === "Float" || props?.data?.datamapVariableType === "Integer" || props?.data?.datamapVariableType === "Long")){
                  flag21 = 1
                  newAttrValue = e.target.value.replace(/[^0-9-.]/g,'')
                } 
                if(props?.data?.style?.CharacterSet === "Uppercase"){
                    if(flag21 === 0){
                        value1 = value1?.toUpperCase()
                    }
                    else{
                        newAttrValue = newAttrValue?.toUpperCase();
                    }
                }

                function get_encr_val(val){
                    return encrypt(val);
                }       
            
                value1_enc.current = await get_encr_val(value1);
                newAttrValue_enc.current = await get_encr_val(newAttrValue);

        var jsonToSend={
            "attrValue": (flag21 === 0 && value1 === "") || (flag21 === 1 && newAttrValue === "") ? "" : flag21 === 0 ?  value1_enc.current : newAttrValue_enc.current,
            "attrType":"password",
            "attrName": props.data.dataclass || userDefinedId || props.data.id
        };
        props.data.value=newValue;
        updateValue(props?.data?.id,newValue, props.containerId,props?.data)
        if(props.data && props.data.event && props.data.event.Events && props.data.event.Events.LostFocus)
    {
        var element=elementRefrence.current;
    element=element.getElementsByTagName("input")[0];
    triggerEventCalls(e,{id:props?.data?.id},props.data.event,props.data.elem_type);
    }
        
    }
    if(AppContextVar!==undefined){
        AppContextVar.applyChanges("conditionalVisibility", {'id' : props.data.id, 'value' :  e.target.value} );
    }
    

}  

    
    
    //Sets the label value into the formState
    const setLabelHandler = (recievedLabel) => {
        // // console.log("recievedLabel ==> ", recievedLabel);
        try{
            if (props.data && props?.data?.style && (props?.data?.style?.Label || props?.data?.id)){
                setDefaultLabel(
                    (prevDefaultLabel) => {
                        if(prevDefaultLabel===recievedLabel){
                            return prevDefaultLabel;
                        } else {
                            props.data.style["Label"] = recievedLabel;
                            updatePartialJSON(props.data.id, props.data);
                            return recievedLabel;
                        }
                    }
                );
                setEditLabel(false);
            }
        }catch(err){
            console.error(err);
        }
    }

    const handleContextMenu = (e) => {
        e.stopPropagation();
      };

    const handleChangeCopy = (e) => {
        if(data && data.style && Object.keys(data.style).length !== 0 && (data.style["AllowCopy"]==="false" || data.style["AllowCopy"]==="1")){
        e.preventDefault();
        }else{
  
        }
      };
  
    const handleChangePaste = (e) => {
        if(data && data.style && Object.keys(data.style).length !== 0 && (data.style["AllowPaste"]==="false" || data.style["AllowCopy"]==="1")){
            e.preventDefault();
            }else{
    
            }
      };

    const handleKeyDown=(event)=>
    {
        if(props.data && props.data.event && props.data.event.Events && props.data.event.Events.KeyDown)
        {
            var element=elementRefrence.current;
            element=element.getElementsByTagName("input")[0];
            triggerEventCalls(event,{id:props?.data?.id},props.data.event,props.data.elem_type);
        }
        if (event.keyCode === 8 || event.keyCode === 16 || event.keyCode === 17 || event.keyCode === 13
            || event.keyCode === 37 || event.keyCode === 40 || event.keyCode === 39 ||
            event.keyCode === 38 || event.keyCode === 46 || event.keyCode === 9  ||  (event.ctrlKey && event.keyCode === 65) ||  // Ctrl + A
            (event.ctrlKey && event.keyCode === 86) ||  // Ctrl + V
            (event.ctrlKey && event.keyCode === 67)
        ){
          } else {
            handleValidation(event);
          }
    }

    const handleValidation = (event) => {
        //var browserLang = window?.psh_configs?.selectedLanguage || window?.psh_configs?.selectedLanguage;
        let typeOfValue = props.data.TypeOfValue;
        let allowFloat = false;
          let allowNumerals = false;
          let allowAlphabets = false;
          let allowSpaces = false;
          let allowSpecialCharacters = false;
          let specialCharacters;
  
          let regexPrefix = "^[";
          let regexString = "";
          let regexSuffix = "]*$";
  
          let regexPassed = false;
          let specialCharacterspassed = false;
          if(typeOfValue == 3 || typeOfValue === "Long" || typeOfValue === "Integer"){
            props.data.style["Numerals"] = "true"
            props.data.style["Alphabets"] = "false"
            props.data.style["Spaces"] = "false"
        }else if(typeOfValue== 10 || typeOfValue === "String"){
            if(props.data.style["Numerals"] === "true")
            props.data.style["Numerals"] = "true"
            if(props.data.style["Alphabets"] === "true")
            props.data.style["Alphabets"] = "true"
            if(props.data.style["Spaces"] === "true")
            props.data.style["Spaces"] = "true"
        }else if(typeOfValue == 6 || typeOfValue === "Float"){
            props.data.style["Numerals"] = "true"
            props.data.style["Alphabets"] = "false"
            props.data.style["Spaces"] = "false";
            allowFloat = true
        }
  
          if (
            props.data &&
            props.data.style &&
            props.data.style["Numerals"] === "true"
          ) {
            allowNumerals = true;
          }
          if (
            props.data &&
            props.data.style &&
            props.data.style["Alphabets"] === "true"
          ) {
            allowAlphabets = true;
          }
          if (
            props.data &&
            props.data.style &&
            props.data.style["Spaces"] === "true"
          ) {
            allowSpaces = true;
          }
          if (
            props.data &&
            props.data.style &&
            props.data.style["AllowSpecialChars"] === "true"
          ) {
            allowSpecialCharacters = true;
            if(props.data?.style["SpecialCharacter"] === undefined || props.data?.style["SpecialCharacter"] === ""){
              if(props.data?.style["SpecialCharacter"] === undefined){
                  props.data.style["SpecialCharacter"] = ""
              }
              specialCharacters = ",.!=@#$%^&*()_+;:[{}'\\/?><`~|\"*\"\\\]-"
           }
           else{
                  specialCharacters = props.data?.style["SpecialCharacter"]
           }
          }
  
          if (allowAlphabets) {
            regexString += "\u0600-\u06FFa-zA-Z";
          }
          if (allowNumerals) {
            regexString += "0-9.";
          }
          if (allowSpaces) {
            regexString += " ";
          }
          if(allowFloat){
            regexString += "\\."
        }
          if (allowSpecialCharacters) {
            regexString += specialCharacters;
          }
          let dynamicRegex = new RegExp(regexPrefix + regexString + regexSuffix);
  
          if (allowNumerals || allowAlphabets || allowSpaces || allowSpecialCharacters) {
            regexPassed = dynamicRegex.test(event.key);
          }
          if(allowSpecialCharacters && (props.data?.style["SpecialCharacter"] === undefined || props.data?.style["SpecialCharacter"] === "") && event.key === "\\"){
              regexPassed = true
          }
          let prevValue = valueOfText;
          if (regexPassed 
            // || specialCharacterspassed
            ) {

          } else {
          
            event.preventDefault();
          }
          return regexPassed
      };
 
    const handleOnFocus=(event)=>
    {
        setIsFocused(true);
        elementRefrence?.current?.focus();
        if(props.data && props.data.event && props.data.event.Events && props.data.event.Events.GotFocus)
        {
            var element=elementRefrence.current;
            element=element.getElementsByTagName("input")[0];
            triggerEventCalls(event,{id:props?.data?.id},props.data.event,props.data.elem_type);
        }
    }

    const handleKeyPress=(event)=>
    {
        if(props.data && props.data.event && props.data.event.Events && 
            (props.data.event.Events.KeyPressF1 || props.data.event.Events.KeyPressF2 || props.data.event.Events.KeyPressF3 || props.data.event.Events.KeyPressF4
            || props.data.event.Events.KeyPressF5 || props.data.event.Events.KeyPressF6 || props.data.event.Events.KeyPressF7 || props.data.event.Events.KeyPressF8
            || props.data.event.Events.KeyPressF9 || props.data.event.Events.KeyPressF10 || props.data.event.Events.KeyPressF11 || props.data.event.Events.KeyPressF12))
            {
                var element=elementRefrence.current;
                element=element.getElementsByTagName("input")[0];
                triggerEventCalls(event,{id:props?.data?.id},props.data.event,props.data.elem_type);
            }
    }


    var inputStylePadding={  
        paddingLeft : padding_left,
        paddingRight : padding_right,
        paddingTop : padding_top,
        paddingBottom : padding_bottom,
        display: "block"
    }

  

   const conditionalClassStyle =props.data && props.data.style && (props.data.style["Enable"]==="true") ?
   { root: classes.textfieldRoot }
  : { root: classes.textfieldRoot2 };

  var col1Size = null;
  var col2Size = null;
    if(labelRatio){
        // console.log("PasswordStyle - inside",labelRatio)
        if(labelRatio === "ratio2"){
            col1Size= 4;
            col2Size = 8;
        }
        if(labelRatio === "ratio3"){
            col1Size= 5;
            col2Size = 7;
        }
        if(labelRatio === "ratio4"){
            col1Size= 6;
            col2Size = 6;
        }
        if(labelRatio === "ratio1"){
            col1Size= 3;
            col2Size = 9;
        }
    }

    if(props.data.style["LabelInputAlignment"] === "Top-Down"){
        labelInputALignment = "Top-Down";
    }
    if(props.data.style["LabelInputAlignment"] === "Left-Right"){
        labelInputALignment = "Left-Right";
    }

    if(controlThemeData?.ControlStyleTextbox === "Style3"){
        labelInputALignment = "Top-Down"
    }


    if(props.previewmode){
         
        if(labelInputALignment==='Left-Right'){
            return (
                <>
                <>
                <Form.Group
                                  style={(mobileDisplay === false || tabDisplay === false || props?.data?.style["Visible"]==="false" || props?.data?.style["Visible"]=== false)? { display: "none" }  : inputStylePadding}
                className={styles2.formStyle + ' spacingThemeControls '}
                 id={userDefinedControlId+'_group'}
                 key={props.data.id || data.id} 
                 control_id={userDefinedControlId+'_group'}
                 elem_type='textbox'  frameindex={data.frameIndex}  elementindex={data.elementIndex}
                 sheetIndex={data.sheetIndex} sheetElementIndex={data.sheetElementIndex} sheetFrameElementindex={data.sheetFrameElementIndex}>
                    <PrepareCSSClass stylingData={themeStyle} />
                    <Row style={{marginLeft:"0px", marginRight:"8px"}}>
                        <Col sm={col1Size == null ? 3 : col1Size} className={"d-flex align-items-center"} style={{paddingRight: "0px"}}>
                        {   props.data && props.data.style && props.data.style["Mandatory"]==="true" ?
                            <ErrorMessageComponent id={data.id}  attribute={"Mandatory"}  version={"tooltip"}
                            controlStyle={props.data.style && props.data.style.ControlStyle ? props.data.style.ControlStyle : "style1"} 
                            parentLabel={props.data.style && props.data.style["Label"] ? props.data.style["Label"] : null}/>
                            :
                            <ErrorMessageComponent id={data.id}  errorMessage={errorMessage}  key={data.id + "_" +errorMessage}
                            controlStyle={props.data.style && props.data.style.ControlStyle ? props.data.style.ControlStyle : "style1"} 
                            parentLabel={props.data.style && props.data.style["Label"] ? props.data.style["Label"] : null}/>
                        }
                            <Form.Label 
                                id={userDefinedControlId+'_label'}
                                className={`textbox_labelStyle1 spacingThemeLabel toggle-mandatory-label${isArabic ? '-arabic' : ''} ${
                                    (props.data.style && props.data.style["Mandatory"]!==undefined && props.data.style["Mandatory"]!==null &&props.data.style.placeholder !== null &&props.data.style["Mandatory"]==="true")?  "mandatory-label " : ""
                                     }`}
                                style={{...inlineStyleForLabel,marginTop: "1px" ,display:'block', lineHeight: `${1.5 * (parseFloat(props?.data?.style?.LabelFontSize || controlThemeData?.LabelFontSize) || 12 )}px`}}
                                control_id={userDefinedControlId+'_label'} 
                                elem_type='textbox'  
                                frameindex={data.frameIndex}  
                                elementindex={data.elementIndex}
                            >
                                <span style={{color: `${props?.data?.style?.LabelFontColor || controlThemeData?.LabelFontColor}`, wordBreak:"break-word",paddingBottom:"3px"}}>
                                {((props.data.style && props.data.style.Label && props.data.style["Label"]) || props?.data?.style?.Label === "") ? props.data.style["Label"] : data.id}
                                </span>
                                {/* {mandatoryElem} */}
                            </Form.Label>
                            {/* {((props.data.style && props.data.style["ToolTip"]) ||props.data.style["ControlDescription"])?
                                <BootstrapTooltip disableFocusListener  placement="top" title={
                                    props.data.style && props.data.style["ToolTip"] && props.data.style["ToolTip"]?
                                    <>
                                        <Typography color="inherit">{props.data.style && props.data.style["ToolTip"]}</Typography>
                                    </>:''
                                }>
                                    {iconForTooltip}
                                </BootstrapTooltip>
                                :<></>
                            } */}
                        </Col>
                        <Col sm={col2Size == null ? 9 : col2Size} className={"d-flex align-items-center"}>
                        {
                            (props.data.style && props.data.style.ControlStyle && props.data.style.ControlStyle==="Style4" && props?.data?.style?.Enable === "false" || (props?.data?.style?.ReadOnlyStyle === "true" || props?.data?.style?.ReadOnlyStyle === true)) ?
                                <>
                                <div style={{display: 'flex'}}>
                                    <span style={inputStyle && inputStyle.style}
                                    classes={{
                                        root: classes.textfieldRoot
                                    }} >
                                        {
                                            props.data.style && props.data.style.DummyData && props.data.style['DummyData']
                                        }
                                    </span>
                                </div>
                                </>
                            :
                            <div style={{width:"100%"}}>
                            <TextField
                            onContextMenu={handleContextMenu}
                            autoComplete='off'
                                error={showMandatoryMsg}
                                fullWidth
                                classes={{
                                    root: classes.textfieldRoot
                                }}
                                variant= {variantStyle}
                                type={ showPassword ? "text" : "password"}
                                InputProps={ props.data?.datamapVariableType === "Float" ?
                                inputStyleForFloatVarMapping : props.data?.datamapVariableType === "Long" ? inputStyleForLongVarMapping : props.data?.datamapVariableType === "Integer" ? inputStyleForIntegerVarMapping : inputStyle}
                                inputProps={{maxLength:props?.data?.datamapVariableType === "String" && props?.data?.datamapVariableLength && props?.data?.datamapVariableLength !== 0 ? props?.data?.datamapVariableLength : undefined, readOnly : (props?.data?.style?.ReadOnly === "true" || props?.data?.style?.ReadOnly === true) ? true : false, tabIndex: isEnable === "false" ? "-1" : activeTabIndex, "data": props?.data, 'aria-label':(`${props?.data?.style?.Label}`)  || "Input Value"}}
                                ref={elementRefrence}
                                value={valueOfText}
                                dataClass={(props.data && props.data.dataclass && props.data.dataclass != null && props.data.dataclass != undefined)?props.data.dataclass:""}
                                onBlur={(e)=>hadleValueChange(e)}
                                onChange={(e)=>handleText(e)}
                                onCopy={handleChangeCopy}
                                onCut={handleChangeCopy}
                                onPaste={handleChangePaste}
                                onKeyDown={(e)=>handleKeyDown(e)}
                                onFocus={(e)=>handleOnFocus(e)}
                                onKeyPress={(e)=>handleKeyPress(e)}
                                id={userDefinedControlId}  
                                control_id={userDefinedControlId} 
                                placeholder={(props.data.style && props.data.style.Placeholder && props.data.style["Placeholder"]) ? props.data.style["Placeholder"] :''}
                                elem_type='textbox'  
                                frameindex={data.frameIndex}  
                                elementindex={data.elementIndex}
                                size="small"
                                icon={<img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`} />}
                            />  
                         {
                    showMandatoryMsg?
                    <MandatoryMsg id={props.data.id} mandatoryMsg={props.data?.style?.ValidationMessage}/>
                    : null
                }
                            </div> 
                        }
                        </Col>
                    </Row>
               
                  </Form.Group>
                </>
                </>
        );
       }
       else
       {
        return (
            <>
            <>
            <Form.Group
                          style={(mobileDisplay === false || tabDisplay === false || props?.data?.style["Visible"] === "false" || props?.data?.style["Visible"]=== false)? { display: "none" }  : inputStylePadding}
            className={styles2.formStyle + ' spacingThemeControls '}
             id={userDefinedControlId+'_group'}
             key={props.data.id || data.id}  
             control_id={userDefinedControlId+'_group'}
             elem_type='textbox'  frameindex={data.frameIndex}  elementindex={data.elementIndex}
             sheetIndex={data.sheetIndex} sheetElementIndex={data.sheetElementIndex} sheetFrameElementIndex={data.sheetFrameElementIndex}>
            <PrepareCSSClass stylingData={themeStyle} />
            
            {
                ((props.data.style && props.data.style.ControlStyle!==undefined && props.data.style.ControlStyle!==null && props.data.style["ControlStyle"]==="Style3") || 
                (controlThemeData && controlThemeData["ControlStyleTextbox"] === 'Style3' && !(Object.keys(props.data.style).includes("ControlStyle"))))
                ?

                    (props.data.style && props.data.style.ControlStyle && props.data.style.ControlStyle==="Style4"  && props?.data?.style?.Enable === "false"  || (props?.data?.style?.ReadOnlyStyle === "true" || props?.data?.style?.ReadOnlyStyle === true)) ?
                        <>
                        <div style={{display: 'flex'}}>
                            <span style={inputStyle && inputStyle.style}
                            classes={{ root: classes.textfieldRoot }}
                            >
                                {
                                    props.data.style && props.data.style.DummyData && props.data.style["DummyData"]
                                }
                            </span>
                        </div>
                        </>
                    :
                        <>
                        <PrepareCSSClass stylingData={themeStyle} />
                        {   props.data && props.data.style && props.data.style["Mandatory"]==="true" ?
                            <ErrorMessageComponent id={data.id}  attribute={"Mandatory"}  version={"tooltip"}
                            controlStyle={props.data.style && props.data.style.ControlStyle ? props.data.style.ControlStyle : "style1"} 
                            parentLabel={props.data.style && props.data.style["Label"] ? props.data.style["Label"] : null}/>
                            :
                            <ErrorMessageComponent id={data.id}  errorMessage={errorMessage}  key={data.id + "_" +errorMessage}
                            controlStyle={props.data.style && props.data.style.ControlStyle ? props.data.style.ControlStyle : "style1"} 
                            parentLabel={props.data.style && props.data.style["Label"] ? props.data.style["Label"] : null}/>
                        }
                        <Form.Label 
                            id={userDefinedControlId+'_label'}
                            style={{visibility:"hidden"}}
                            className={'textbox_labelStyle1'}
                            control_id={props.data.id} 
                            elem_type='textbox'  
                            frameindex={data.frameIndex}  
                            elementindex={data.elementIndex}
                        >
                            {((props.data.style && props.data.style.Label && props.data.style["Label"]) || props?.data?.style?.Label === "") ? props.data.style["Label"] : data.id}
                            
                        </Form.Label>
                        <div style={{width:"100%"}}>
                        <TextField 
                        onContextMenu={handleContextMenu}
                        autoComplete='off'
                            id={userDefinedControlId} 
                            error={showMandatoryMsg}
                            control_id={props.data.id} 
                            elem_type='textbox'  
                            frameindex={data.frameIndex}  
                            elementindex={data.elementIndex}
                            variant= "outlined"
                            fullWidth
                            label = {((props.data.style && props.data.style.Label && props.data.style["Label"]) || props?.data?.style?.["Label"] === "") ? 
                                <div style={{"display":"block",
                                "margin-left" : (props?.data?.style?.ControlStyle === "Style3" || controlThemeData["ControlStyleTextbox"] === 'Style3') && props?.data?.style?.icon ? "6px" : "2px",
                                "margin-right" : "2px",
                                 color: (props?.data?.style?.LabelFontColor || controlThemeData?.LabelFontColor || "#606060"), 
                                 "font-family": themeJsonForLabel["font-family"],
                                  fontWeight: themeJsonForLabel["font-weight"], 
                                  "font-style": themeJsonForLabel["font-style"],
                                    wordBreak:"break-word", 
                                    "font-size": props?.data?.style?.LabelFontSize || controlThemeData?.LabelFontSize||"12px",
                                    lineHeight: `${1.5 * (parseFloat(props?.data?.style?.LabelFontSize || controlThemeData?.LabelFontSize) || 12)}px`,
                                    ...inlineStyleForLabel}}
                                     id={userDefinedControlId+'_label'}
                                className={`toggle-mandatory-label${isArabic ? '-arabic' : ''} ${
                                    (props.data.style && props.data.style["Mandatory"]!==undefined && props.data.style["Mandatory"]!==null &&props.data.style.placeholder !== null &&props.data.style["Mandatory"]==="true")?  "mandatory-label " : ""
                                     }`}
                                >
                                    {props.data.style["Label"] }
                                    {/* {mandatoryElem} */}
                                </div>
                                :
                                <div style={{"display":"block","margin-left" : (props?.data?.style?.ControlStyle === "Style3" || controlThemeData["ControlStyleTextbox"] === 'Style3') && props?.data?.style?.icon ? "6px" : "2px",
                                "margin-right" : "2px", color: props?.data?.style?.LabelFontColor || controlThemeData?.LabelFontColor || "#606060",
                                 "font-family": themeJsonForLabel["font-family"], 
                                 fontWeight: themeJsonForLabel["font-weight"],
                                  "font-style": themeJsonForLabel["font-style"], 
                                  wordBreak:"break-word", 
                                  "font-size": props?.data?.style?.LabelFontSize || controlThemeData?.LabelFontSize || "12px", 
                                  lineHeight: `${1.5 * (parseFloat(props?.data?.style?.LabelFontSize || controlThemeData?.LabelFontSize) || 12)}px`,
                                  ...inlineStyleForLabel}}
                                className={`toggle-mandatory-label${isArabic ? '-arabic' : ''} ${
                                    (props.data.style && props.data.style["Mandatory"]!==undefined && props.data.style["Mandatory"]!==null &&props.data.style.placeholder !== null &&props.data.style["Mandatory"]==="true")?  "mandatory-label " : ""
                                     }`}
                                >
                                    {data.id}
                                    {/* {mandatoryElem} */}
                                </div>
                            }
                            type={ showPassword ? "text" : "password"}
                            
                            InputProps={ props.data?.datamapVariableType === "Float" ?
                            inputStyleForFloatVarMapping3 : props.data?.datamapVariableType === "Long" ? inputStyleForLongVarMapping3 : props.data?.datamapVariableType === "Integer" ? inputStyleForIntegerVarMapping3 : inputStyleForStyle3}
                            inputProps={{maxLength:props?.data?.datamapVariableType === "String" && props?.data?.datamapVariableLength && props?.data?.datamapVariableLength !== 0 ? props?.data?.datamapVariableLength : undefined, readOnly : (props?.data?.style?.ReadOnly === "true" || props?.data?.style?.ReadOnly === true) ? true : false, tabIndex: isEnable === "false" ? "-1" : activeTabIndex, "data": props?.data, 'aria-label': (`${props?.data?.style?.Label}`)  || "Input Value"}}
                            ref={elementRefrence}
                            value={valueOfText}
                            dataClass={(props.data && props.data.dataclass && props.data.dataclass != null && props.data.dataclass != undefined)?props.data.dataclass:""}
                            onBlur={(e)=>hadleValueChange(e)}
                            onChange={(e)=>handleText(e)} 
                            onCopy={handleChangeCopy}
                            onCut={handleChangeCopy}
                            onPaste={handleChangePaste}
                            onKeyDown={(e)=>handleKeyDown(e)}
                            onFocus={(e)=>handleOnFocus(e)}
                            onKeyPress={(e)=>handleKeyPress(e)}
                            placeholder={(props.data.style && props.data.style.Placeholder && props.data.style["Placeholder"]) ? props.data.style["Placeholder"] :''}
                            classes={conditionalClassStyle}
                        />
                        {
                        showMandatoryMsg ?
                            <MandatoryMsg id={props.data.id} mandatoryMsg={props.data?.style?.ValidationMessage}/>
                            : null
                        }
                        </div>
                        </>         
                :  
                    <>
                    <PrepareCSSClass stylingData={themeStyle} />
                    {   props.data && props.data.style && props.data.style["Mandatory"]==="true" ?
                            <ErrorMessageComponent id={data.id}  attribute={"Mandatory"}  version={"tooltip"}
                            controlStyle={props.data.style && props.data.style.ControlStyle ? props.data.style.ControlStyle : "style1"} 
                            parentLabel={props.data.style && props.data.style["Label"] ? props.data.style["Label"] : null}/>
                            :
                            <ErrorMessageComponent id={data.id}  errorMessage={errorMessage}  key={data.id + "_" +errorMessage}
                            controlStyle={props.data.style && props.data.style.ControlStyle ? props.data.style.ControlStyle : "style1"} 
                            parentLabel={props.data.style && props.data.style["Label"] ? props.data.style["Label"] : null}/>
                        }
                    <Form.Label 
                        id={userDefinedControlId+'_label'}
                        style={{...inlineStyleForLabel,marginTop: props.data?.style["LabelInputAlignment"] === "Left-Right" ? "1px" : "0px", lineHeight: `${1.5 * (parseFloat(props?.data?.style?.LabelFontSize || controlThemeData?.LabelFontSize) || 12)}px`}}
                        className={'textbox_labelStyle1'+' spacingThemeLabel '}
                        control_id={props.data.id} elem_type='textbox'  frameindex={data.frameIndex}  elementindex={data.elementIndex}>
                            <span className={`toggle-mandatory-label${isArabic ? '-arabic' : ''} ${
                                    (props.data.style && props.data.style["Mandatory"]!==undefined && props.data.style["Mandatory"]!==null &&props.data.style.placeholder !== null &&props.data.style["Mandatory"]==="true")?  "mandatory-label " : ""
                                     }`} style={{color: `${props?.data?.style?.LabelFontColor || controlThemeData?.LabelFontColor}`, wordBreak:"break-word"}}>
                            {((props.data.style && props.data.style.Label && props.data.style["Label"]) || props?.data?.style?.Label === "") ? props.data.style["Label"] : data.id}
                            </span>
                            {/* {mandatoryElem} */}
                    </Form.Label> 


                    {(props.data && props.data.style && props.data.style["ValidationMessage"] )?
                        <>
                            <span className="tooltipIcon" > < span className="tooltipIcon"></span></span>
                            <span className={"tooltip2 tooltipTop" }  > 
                            {t(`translation:${props.data.style["ValidationMessage"] }`)}
                            </span>
                        </>
                        :
                        <></>
                    }
                    {
                        (props.data.style && props.data.style.ControlStyle && props.data.style.ControlStyle==="Style4" && props?.data?.style?.Enable === "false" || (props?.data?.style?.ReadOnlyStyle === "true" || props?.data?.style?.ReadOnlyStyle === true)) ?
                            <>
                            <Form.Label>&nbsp;</Form.Label>
                            <div style={{display: 'flex'}}>
                                <span style={inputStyle && inputStyle.style}
                            classes={{
                            root: classes.textfieldRoot
                            }}
                                >
                                    {
                                        props.data.style && props.data.style.DummyData && props.data.style["DummyData"]
                                    }
                                </span>
                            </div>
                            </>
                        :
                        <div style={{width:"100%"}}>
                        <TextField 
                        onContextMenu={handleContextMenu}
                        autoComplete='off'
                            error={showMandatoryMsg}
                            fullWidth
                            classes={ conditionalClassStyle}
                            variant= {variantStyle}   
                            type={ showPassword ? "text" : "password"}       
                            InputProps={ props.data?.datamapVariableType === "Float" ?
                            inputStyleForFloatVarMapping : props.data?.datamapVariableType === "Long" ? inputStyleForLongVarMapping : props.data?.datamapVariableType === "Integer" ? inputStyleForIntegerVarMapping : inputStyle}
                            inputProps={{maxLength:props?.data?.datamapVariableType === "String" && props?.data?.datamapVariableLength && props?.data?.datamapVariableLength !== 0 ? props?.data?.datamapVariableLength : undefined, readOnly : (props?.data?.style?.ReadOnly === "true" || props?.data?.style?.ReadOnly === true) ? true : false, tabIndex: isEnable === "false" ? "-1" : activeTabIndex, "data": props?.data, 'aria-label': (`${props?.data?.style?.Label}`)  || "Input Value"}}
                            id={userDefinedControlId} 
                            control_id={userDefinedControlId}
                            ref={elementRefrence}
                            value={valueOfText}
                            dataClass={(props.data && props.data.dataclass && props.data.dataclass != null && props.data.dataclass != undefined)?props.data.dataclass:""}
                            onBlur={(e)=>hadleValueChange(e)}
                            onCopy={handleChangeCopy}
                            onCut={handleChangeCopy}
                            onPaste={handleChangePaste}
                            onChange={(e)=>handleText(e)}  
                            onKeyDown={(e)=>handleKeyDown(e)}
                            onFocus={(e)=>handleOnFocus(e)}
                            onKeyPress={(e)=>handleKeyPress(e)}
                            placeholder={(props.data.style && props.data.style.Placeholder && props.data.style["Placeholder"]) ? props.data.style["Placeholder"] :''}
                            elem_type='textbox'  
                            frameindex={data.frameIndex}  
                            elementindex={data.elementIndex}
                            size="small"  
                        >
                    
                        </TextField>
                    {
                showMandatoryMsg?
                <MandatoryMsg id={props.data.id} mandatoryMsg={props.data?.style?.ValidationMessage}/>
                : null
            }
                        </div>
                    }
                    </>    
            }            
            
           
            </Form.Group>
            </>
           </>
          ); 
       }
    } 
    else {
        if(labelInputALignment==='Left-Right'){
            return (
                <Form.Group id={userDefinedControlId+'_group'}
                onClick={(e)=>props.handleSelected(e,props.data.id,"n")}
                onKeyDown={(e) => props.handleSelected(e)}
                
                style={inputStylePadding}
                className={styles2.formStyle + ' spacingThemeControls ' }
                 key={props.data.id} control_id={data.id} tabIndex={activeTabIndex} elem_type='textbox'  frameindex={data.frameIndex}  elementindex={data.elementIndex}
                 sheetIndex={data.sheetIndex} sheetElementIndex={data.sheetElementIndex} sheetFrameElementindex={data.sheetFrameElementIndex}>
                    <PrepareCSSClass stylingData={themeStyle} />
                    <Row style={{marginLeft:"0px", marginRight:"8px"}}>
                    <Col sm={col1Size == null ? 3 : col1Size} className={"d-flex align-items-center"} style={{paddingRight: "0px"}}>
                        {   props.data && props.data.style && props.data.style["Mandatory"]==="true" ?
                            <ErrorMessageComponent id={data.id}  attribute={"Mandatory"}  version={"tooltip"}
                            controlStyle={props.data.style && props.data.style.ControlStyle ? props.data.style.ControlStyle : "style1"} 
                            parentLabel={props.data.style && props.data.style["Label"] ? props.data.style["Label"] : null}/>
                            :
                            <ErrorMessageComponent id={data.id}  errorMessage={errorMessage}  key={data.id + "_" +errorMessage}
                            controlStyle={props.data.style && props.data.style.ControlStyle ? props.data.style.ControlStyle : "style1"} 
                            parentLabel={props.data.style && props.data.style["Label"] ? props.data.style["Label"] : null}/>
                        }
                        <EditableLabel 
                            defaultLabel={
                                <Form.Label 
                                id={userDefinedControlId+'_label'}
                                onDoubleClick={bringEditableLabel}
                                className={['textbox_labelStyle1' ,'styled '].join(" ")+' spacingThemeLabel '}  
                                style={{...inlineStyleForLabel,marginTop: "1px", lineHeight: `${1.5 * (parseFloat(props?.data?.style?.LabelFontSize || controlThemeData?.LabelFontSize) || 12)}px`}} control_id={props.data.id} elem_type='textbox' frameindex={data.frameIndex}  elementindex={data.elementIndex}>
                                     <span className={`toggle-mandatory-label${isArabic ? '-arabic' : ''} ${
                                    (props.data.style && props.data.style["Mandatory"]!==undefined && props.data.style["Mandatory"]!==null &&props.data.style.placeholder !== null &&props.data.style["Mandatory"]==="true")?  "mandatory-label " : ""
                                     }`}  style={{color: `${props?.data?.style?.LabelFontColor || controlThemeData?.LabelFontColor}`, wordBreak:"break-word"}}>
                                     {((props.data.style && props.data.style.Label && props.data.style["Label"]) || props?.data?.style?.Label === "") ? props.data.style["Label"] : data.id}
                                    </span>
                                    {/* {mandatoryElem} */}
                                </Form.Label>
                            }
                            editlabel={editLabel}
                            default_value={defaultLabel}
                            setLabelHandler={(recievedLabel)=>setLabelHandler(recievedLabel)}
                            style={{...inlineStyleForLabel,marginTop:"1px"}}
                            className={'styled '} 
                        />
                   
                        {/* {(props.data.style && props.data.style["ToolTip"] || props.data.style && props.data.style["ControlDescription"])?
                            <BootstrapTooltip 
                                disableFocusListener 
                                placement="top" 
                                title={
                                    props.data.style && props.data.style["ToolTip"]?
                                    <>
                                        <Typography color="inherit">{props.data.style && props.data.style["ToolTip"]}</Typography>
                                    </>:''
                                }
                            >
                                {iconForTooltip}
                            </BootstrapTooltip>:
                            <></>
                        } */}
                    
                    </Col>
                    <Col sm={col2Size == null ? 9 : col2Size} className={"d-flex align-items-center"}>
                    {
                      
                    <TextField
             
                      fullWidth

                    classes={{
                        root: classes.textfieldRoot2
                      }}
                      variant= {variantStyle}

                      type={ showPassword ? "text" : "password"}
                      InputProps={ inputStyle}
                  
    
                      id={userDefinedControlId} 
                      inputProps={{tabIndex:"-1", "data": props?.data, 'aria-label': (`${props?.data?.style?.Label}`)  || "Input Value" }}
                      control_id={props.data.id} 
                      icon={<img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`} />}
                      placeholder={(props.data.style && props.data.style.Placeholder && props.data.style["Placeholder"]) ? props.data.style["Placeholder"] :''}
                      elem_type='textbox'  
                      frameindex={data.frameIndex}  
                      elementindex={data.elementIndex}
                      size="small"
                    />  
                    }
                    </Col>
                </Row>
        
        
                {controlSelected?.id === props?.id &&
                <ElemDeleteControl 
                    containerId={props.containerId}
                    id={props.data.id} 
                    deleteControl={deleteControl} 
                    elemType={props.data.elem_type}
                    setDragging={props.setDragging}
                    handleReorderStart={props.handleReorderStart}
                    handleReorderDrop={props.handleReorderDrop} 
                    data={data}
                    dragId={props.dragId}
                    dragType={'column'}
                />   
        }        
                    {
                        window?.openQuickTools && open &&  
                        <QuickTools containerId={props.containerId} key={props.data.id} selectedControl={props.data} open={open} setOpen={setOpen} />
                    }
                </Form.Group>
            );
        }
        else{
            return (
                <>
                <Form.Group
                    onClick={(e)=>props.handleSelected(e,props.data.id,"n")}
                    onKeyDown={(e) => props.handleSelected(e)}
                    style={inputStylePadding}
                    id={userDefinedControlId+"_group"}
                    className={styles2.formStyle + ' spacingThemeControls '}
                    key={props.data.id || data.id} 
                    control_id={data.id} 
                    tabIndex={activeTabIndex}
                    elem_type='textbox'  
                    frameindex={data.frameIndex}  
                    elementindex={data.elementIndex}
                    sheetIndex={data.sheetIndex} 
                    sheetElementIndex={data.sheetElementIndex} 
                    sheetFrameElementindex={data.sheetFrameElementIndex}
                >
                <PrepareCSSClass stylingData={themeStyle} />
                {
                ((props?.data?.style?.ControlStyle && props?.data?.style["ControlStyle"]==="Style3") || (controlThemeData && controlThemeData["ControlStyleTextbox"] === 'Style3' && !(Object.keys(props.data.style).includes("ControlStyle"))))
                ?

                    <>
                        <Form.Label 
                            id={userDefinedControlId+'_label'}
                            style={{visibility:"hidden"}}
                            className={'textbox_labelStyle1'}
                            control_id={props.data.id} 
                            elem_type='textbox'  
                            frameindex={data.frameIndex}  
                            elementindex={data.elementIndex}
                        >
                            {((props.data.style && props.data.style.Label && props.data.style["Label"]) || props?.data?.style?.Label === "") ? props.data.style["Label"] : data.id}
                            
                        </Form.Label>
                        <TextField 
                            id={userDefinedControlId}
                            control_id={props.data.id} 
                            elem_type='textbox'  
                            frameindex={data.frameIndex}  
                            elementindex={data.elementIndex}
                            variant= "outlined"
                            fullWidth
                            InputProps={inputStyleForStyle3}
                            inputProps={{tabIndex:activeTabIndex, "data": props?.data, 'aria-label': (`${props?.data?.style?.Label}`)  || "Input Value"}}
                            type={ showPassword ? "text" : "password"}
                            label= {((props.data.style && props.data.style.Label && props.data.style["Label"]) || props?.data?.style?.["Label"] === "") ? 
                                <div className={`toggle-mandatory-label${isArabic ? '-arabic' : ''} ${
                                    (props.data.style && props.data.style["Mandatory"]!==undefined && props.data.style["Mandatory"]!==null &&props.data.style.placeholder !== null &&props.data.style["Mandatory"]==="true")?  "mandatory-label " : ""
                                     }`} style={{"margin-left" : (props?.data?.style?.ControlStyle === "Style3" || controlThemeData["ControlStyleTextbox"] === 'Style3') && props?.data?.style?.icon ? "6px" : "2px",
                                "margin-right" : "2px",  
                                "font-family": themeJsonForLabel["font-family"], fontWeight: themeJsonForLabel["font-weight"], 
                                "font-style": themeJsonForLabel["font-style"], 
                                 color: props?.data?.style?.LabelFontColor || controlThemeData?.LabelFontColor || "#606060", 
                                   wordBreak:"break-word", 
                                   "font-size": props?.data?.style?.LabelFontSize || controlThemeData?.LabelFontSize || "12px",
                                   lineHeight: `${1.5 * (parseFloat(props?.data?.style?.LabelFontSize || controlThemeData?.LabelFontSize) || 12)}px`, 
                                   ...inlineStyleForLabel}} id={userDefinedControlId+'_label'} >   
                                    {props.data.style["Label"] }
                                    {/* {mandatoryElem} */}
                                </div>
                                :
                                <div className={`toggle-mandatory-label${isArabic ? '-arabic' : ''} ${
                                    (props.data.style && props.data.style["Mandatory"]!==undefined && props.data.style["Mandatory"]!==null &&props.data.style.placeholder !== null &&props.data.style["Mandatory"]==="true")?  "mandatory-label " : ""
                                     }`} style={{color: props?.data?.style?.LabelFontColor || controlThemeData?.LabelFontColor || "#606060", 
                                     "font-family": themeJsonForLabel["font-family"], 
                                     fontWeight: themeJsonForLabel["font-weight"], 
                                     "font-style": themeJsonForLabel["font-style"], 
                                     wordBreak:"break-word", 
                                     "font-size": props?.data?.style?.LabelFontSize || controlThemeData?.LabelFontSize||"12px",
                                     lineHeight: `${1.5 * (parseFloat(props?.data?.style?.LabelFontSize || controlThemeData?.LabelFontSize) || 12)}px`, 
                                     ...inlineStyleForLabel}} id={userDefinedControlId+'_label'} >
                                    {props.data.id}
                                    {/* {mandatoryElem} */}
                                </div>
                            }
                            classes={{
                                root: classes.textfieldRoot2, 
                            }}
                            placeholder={(props.data.style && props.data.style.Placeholder && props.data.style["Placeholder"]) ? props.data.style["Placeholder"] :''}
                            className={'valueStyle1' + ' ' + 'inputStyle1'}
                        />

                    </>         
                :  
                    <>
                        <EditableLabel
                            defaultLabel={
                                <Form.Label 
                                    id={userDefinedControlId+'_label'}
                                    onDoubleClick={bringEditableLabel}
                                    style={{...inlineStyleForLabel,marginTop: props.data?.style["LabelInputAlignment"] === "Left-Right" ? "1px" : "0px",lineHeight: `${1.5 * (parseFloat(props?.data?.style?.LabelFontSize || controlThemeData?.LabelFontSize) || 12)}px`}}
                                    className={'textbox_labelStyle1'+' spacingThemeLabel '}
                                    control_id={props.data.id} 
                                    elem_type='textbox'  
                                    frameindex={data.frameIndex}  
                                    elementindex={data.elementIndex}
                                >
                                    <span className={`toggle-mandatory-label${isArabic ? '-arabic' : ''} ${
                                    (props.data.style && props.data.style["Mandatory"]!==undefined && props.data.style["Mandatory"]!==null &&props.data.style.placeholder !== null &&props.data.style["Mandatory"]==="true")?  "mandatory-label " : ""
                                     }`} style={{color: `${props?.data?.style?.LabelFontColor || controlThemeData?.LabelFontColor}`, wordBreak:"break-word"}}>
                                    {((props.data.style && props.data.style.Label && props.data.style["Label"]) || props?.data?.style?.Label === "") ? props.data.style["Label"] : data.id}
                                    {/* {mandatoryElem} */}
                                    {/* {(props.data.style && props.data.style["ToolTip"] || props.data.style && props.data.style["ControlDescription"]) ? 
                                        <BootstrapTooltip 
                                            disableFocusListener  
                                            placement="top" 
                                            title={ props.data.style && props.data.style["ToolTip"] 
                                                && props.data.style["ToolTip"] ?
                                                    <>
                                                    <Typography color="inherit">
                                                        {props.data.style && props.data.style["ToolTip"]}
                                                    </Typography>
                                                    </>
                                                : ''
                                            }
                                        >
                                            {iconForTooltip}
                                        </BootstrapTooltip> 
                                    : <></>
                                    } */}
                                    </span>
                                </Form.Label>
                            }
                            editlabel={editLabel}
                            default_value={defaultLabel}
                            setLabelHandler={(recievedLabel)=>setLabelHandler(recievedLabel)}
                        />
                        {
                        <>
                            <TextField
                                fullWidth
                                control_id={props.data.id}   
                                classes={{
                                    root: classes.textfieldRoot2
                                }}
                                inputProps={{tabIndex:"-1","data": props?.data, 'aria-label': (`${props?.data?.style?.Label}`) || "Input Value"}}
                                variant= {variantStyle} 
                                type={ showPassword ? "text" : "password"}        
                                InputProps={inputStyle }
                                icon={<img alt="Img Icon" className={iconStyle}  src={`${imageBaseURL}${iconFile}${loadArabicImage(imageBaseURL)}`} />}
                                id={userDefinedControlId} 
                                placeholder={(props.data.style && props.data.style.Placeholder && props.data.style["Placeholder"]) ? props.data.style["Placeholder"] :''}
                                elem_type='textbox'  
                                frameindex={data.frameIndex}  
                                elementindex={data.elementIndex}
                                size="small"  
                            />
                        </>
                        }       
                            
                    </>
        
                }
                {controlSelected?.id === props?.id &&
                <ElemDeleteControl 
                    containerId={props.containerId}
                    id={props.data.id} 
                    deleteControl={deleteControl} 
                    elemType={props.data.elem_type}
                    setDragging={props.setDragging}
                    handleReorderStart={props.handleReorderStart}
                    handleReorderDrop={props.handleReorderDrop} 
                    data={data}
                    dragId={props.dragId}
                    dragType={'column'}
                />   
        }      
                </Form.Group>
                {
                        window?.openQuickTools && open &&  
                <QuickTools containerId={props.containerId} key={props.data.id} selectedControl={props.data} open={open} setOpen={setOpen} />
        }
                </>
            ); 
        }
    }
}

export default TEXTBOX
